// DO NOT EDIT!!! This file is auto-generated.

export const LOCALES_SUPPORTED = [
  'ar',
  'cs',
  'da',
  'de',
  'en',
  'es',
  'fi',
  'fr',
  'he',
  'hi',
  'it',
  'ja',
  'ko',
  'nb',
  'nl',
  'sv',
  'zh-CN',
  'zh-TW',
] as const;
export const LOCALE_DEFAULT: LocaleSupported = 'en';

export type LocaleSupported = (typeof LOCALES_SUPPORTED)[number];

export type MessageKey =
  | '1_year_membership'
  | '1_year_membership_details'
  | '1_year_protection_plan'
  | '1_year_warranty'
  | '10pm_bedtime_app_ui'
  | '12_months_prepaid'
  | '12pm_daily_scores_bottom_app_ui'
  | '12pm_daily_scores_top_app_ui'
  | '2_day_shipping'
  | '2_year_protection_plan'
  | '20_days_of_pto'
  | '20_phd_copy'
  | '20_phd_heading'
  | '24_7_support'
  | '24_7_support_subcopy'
  | '3_gen_copy'
  | '3_year_protection_plan'
  | '30_day_returns'
  | '3pm_daytime_stress_app_ui'
  | '4_gen_heading'
  | '404_back_to_home'
  | '404_back_to_home_new'
  | '404_caption'
  | '404_oura_home'
  | '404_title'
  | '699_oura_members_survey_footnote'
  | '6am_readiness_app_ui'
  | '6am_time_asleep_app_ui'
  | '6pm_summary_app_ui'
  | '6pm_tag_entry_app_ui'
  | '8_days_battery_life'
  | 'a_really_smart_ring_title'
  | 'ab_membership_modal_heading'
  | 'ab_membership_modal_list'
  | 'ab_membership_modal_title'
  | 'about_us'
  | 'about_us_aim_higher'
  | 'about_us_aim_higher_copy'
  | 'about_us_data_copy'
  | 'about_us_data_title'
  | 'about_us_hero_copy'
  | 'about_us_hero_title'
  | 'about_us_human_first'
  | 'about_us_human_first_copy'
  | 'about_us_medical_alt'
  | 'about_us_medical_copy'
  | 'about_us_medical_title'
  | 'about_us_not_me'
  | 'about_us_not_me_copy'
  | 'about_us_secondary_alt_1'
  | 'about_us_secondary_alt_2'
  | 'about_us_secondary_alt_3'
  | 'about_us_secondary_copy'
  | 'about_us_secondary_title'
  | 'about_us_stat_caption_1'
  | 'about_us_stat_caption_2'
  | 'about_us_stat_caption_3'
  | 'about_us_stat_caption_4'
  | 'about_us_stat_figure_1'
  | 'about_us_stat_figure_1_updated'
  | 'about_us_stat_figure_2'
  | 'about_us_stat_figure_2_updated'
  | 'about_us_stat_figure_3'
  | 'about_us_stat_figure_3_updated'
  | 'about_us_stat_figure_4'
  | 'about_us_stat_figure_4_updated'
  | 'about_us_trust_matters'
  | 'about_us_trust_matters_copy'
  | 'about_us_we_find_solutions'
  | 'about_us_we_find_solutions_copy'
  | 'about_zirconia_ceramic_copy'
  | 'about_zirconia_ceramic_title'
  | 'accept_cookies'
  | 'access_and_use'
  | 'accessibility_body_1'
  | 'accessibility_body_2'
  | 'accessibility_contact_us'
  | 'accessibility_title'
  | 'accessories_to_complete_experience'
  | 'accolades_cb_insights'
  | 'accolades_fast_company'
  | 'accolades_real_simple'
  | 'accolades_theverge'
  | 'accolades_time'
  | 'accolades_vogue'
  | 'accolades_wirecutter'
  | 'accolades_wired'
  | 'account_information'
  | 'accuracy_description'
  | 'accuracy_title'
  | 'acitivy_article_one'
  | 'acitivy_article_three'
  | 'acitivy_article_two'
  | 'acknowledgment_required_footnote'
  | 'activity_and_movement_link'
  | 'activity_and_movement_testimonial_charlie_r'
  | 'activity_app_image_alt'
  | 'activity_app_ui'
  | 'activity_automatic_title'
  | 'activity_corepoweryoga_copy'
  | 'activity_features_eyebrow'
  | 'activity_features_one_alt'
  | 'activity_features_one_img'
  | 'activity_features_one_img_updated'
  | 'activity_features_score_title'
  | 'activity_features_three_alt'
  | 'activity_features_three_img'
  | 'activity_features_two_alt'
  | 'activity_features_two_img'
  | 'activity_footer_alt'
  | 'activity_footer_title'
  | 'activity_goal_app_ui'
  | 'activity_goal_image_alt'
  | 'activity_google_apple_copy'
  | 'activity_hero_copy'
  | 'activity_hero_eyebrow'
  | 'activity_hero_title'
  | 'activity_integration_apple'
  | 'activity_integration_health_connect'
  | 'activity_integration_strava'
  | 'activity_integration_wild'
  | 'activity_integrations_copy'
  | 'activity_integrations_title'
  | 'activity_jumbotron_eyebrow'
  | 'activity_jumbotron_title'
  | 'activity_marcus_quote'
  | 'activity_meta_data_description'
  | 'activity_meta_data_title'
  | 'activity_personalized_title'
  | 'activity_recovery_tag'
  | 'activity_rhonda_quote'
  | 'activity_sculpt_society_copy'
  | 'activity_sleep_tag'
  | 'activity_strava_copy'
  | 'activity_technogym_copy'
  | 'activity_testimonial_tag'
  | 'activity_testimonials_three_alt'
  | 'activity_testimonials_two_alt'
  | 'activity_tracking_accordion_item_1_content'
  | 'activity_tracking_accordion_item_1_header'
  | 'activity_tracking_accordion_item_2_content'
  | 'activity_tracking_accordion_item_2_header'
  | 'activity_tracking_accordion_item_3_content'
  | 'activity_tracking_accordion_item_3_header'
  | 'activity_tracking_accordion_item_4_content'
  | 'activity_tracking_accordion_item_4_header'
  | 'activity_tracking_accordion_item_5_content'
  | 'activity_tracking_accordion_item_5_header'
  | 'activity_tracking_accordion_item_6_content'
  | 'activity_tracking_accordion_item_6_header'
  | 'activity_tracking_copy'
  | 'activity_tracking_img_alt'
  | 'activity_tracking_title'
  | 'activity_wild_copy'
  | 'add_new_address'
  | 'add_ons'
  | 'add_ons_3_ring_limit'
  | 'add_ons_one_year_prepaid_copy'
  | 'added'
  | 'adding'
  | 'address_error'
  | 'address_form_additional_address'
  | 'address_form_address'
  | 'address_form_apt_suite'
  | 'address_form_city'
  | 'address_form_city_town'
  | 'address_form_city_ward_town_village'
  | 'address_form_country'
  | 'address_form_county'
  | 'address_form_email'
  | 'address_form_emirate'
  | 'address_form_fname'
  | 'address_form_lname'
  | 'address_form_max'
  | 'address_form_min'
  | 'address_form_phone'
  | 'address_form_postal'
  | 'address_form_postcode'
  | 'address_form_prefecture'
  | 'address_form_province'
  | 'address_form_region'
  | 'address_form_required'
  | 'address_form_state'
  | 'address_form_state_province_region'
  | 'address_form_state_territory'
  | 'address_form_street_house_number'
  | 'address_form_suburb'
  | 'address_form_zip'
  | 'address_suggestion_title'
  | 'adyen_hsafsa_label'
  | 'adyen_klarna_klarna_account_label'
  | 'adyen_klarna_klarna_label'
  | 'adyen_klarna_klarna_paynow_label'
  | 'affirm'
  | 'all_features'
  | 'allow_tracking_for_category'
  | 'already_know_or_4_size'
  | 'amazing_culture'
  | 'amazon_eyebrow_translated_icon'
  | 'amazon_now_available_eyebrow'
  | 'ambassador_program'
  | 'amex'
  | 'an_oura_ring'
  | 'an_oura_ring_of_your_own'
  | 'and'
  | 'andy_walshe'
  | 'anyone_everyone_body'
  | 'anyone_everyone_title'
  | 'api_integration'
  | 'apple_pay'
  | 'apply_for_partner_program'
  | 'april_2024'
  | 'aria_label_products'
  | 'aria_role_description_carousel'
  | 'aria_role_description_carousel_slide'
  | 'AU_region_ACT'
  | 'AU_region_NSW'
  | 'AU_region_NT'
  | 'AU_region_QLD'
  | 'AU_region_SA'
  | 'AU_region_TAS'
  | 'AU_region_VIC'
  | 'AU_region_WA'
  | 'aug_app_ui_2025'
  | 'august'
  | 'august_2023'
  | 'august_2024'
  | 'august_app_image_alt'
  | 'august_app_ui'
  | 'available_day'
  | 'available_in_select_countries'
  | 'avonte_cb_job_title'
  | 'avonte_quote'
  | 'b2b_terms_1_1_def'
  | 'b2b_terms_1_1_term'
  | 'b2b_terms_1_10_def'
  | 'b2b_terms_1_10_term'
  | 'b2b_terms_1_11_def'
  | 'b2b_terms_1_11_term'
  | 'b2b_terms_1_2_def'
  | 'b2b_terms_1_2_term'
  | 'b2b_terms_1_3_def'
  | 'b2b_terms_1_3_term'
  | 'b2b_terms_1_4_def'
  | 'b2b_terms_1_4_term'
  | 'b2b_terms_1_5_def'
  | 'b2b_terms_1_5_term'
  | 'b2b_terms_1_6_def'
  | 'b2b_terms_1_6_term'
  | 'b2b_terms_1_7_def'
  | 'b2b_terms_1_7_term'
  | 'b2b_terms_1_8_def'
  | 'b2b_terms_1_8_term'
  | 'b2b_terms_1_9_def'
  | 'b2b_terms_1_9_term'
  | 'b2b_terms_1_title'
  | 'b2b_terms_10_1_def'
  | 'b2b_terms_10_10_def'
  | 'b2b_terms_10_11_def'
  | 'b2b_terms_10_12_def'
  | 'b2b_terms_10_13_def'
  | 'b2b_terms_10_14_def'
  | 'b2b_terms_10_15_def'
  | 'b2b_terms_10_16_def'
  | 'b2b_terms_10_17_def'
  | 'b2b_terms_10_18_def'
  | 'b2b_terms_10_19_def'
  | 'b2b_terms_10_2_def'
  | 'b2b_terms_10_20_def'
  | 'b2b_terms_10_21_def'
  | 'b2b_terms_10_22_def'
  | 'b2b_terms_10_23_def'
  | 'b2b_terms_10_24_def'
  | 'b2b_terms_10_3_def'
  | 'b2b_terms_10_4_def'
  | 'b2b_terms_10_5_def'
  | 'b2b_terms_10_6_def'
  | 'b2b_terms_10_7_def'
  | 'b2b_terms_10_8_def'
  | 'b2b_terms_10_9_def'
  | 'b2b_terms_10_title'
  | 'b2b_terms_2_1_def'
  | 'b2b_terms_2_1_term'
  | 'b2b_terms_2_2_def'
  | 'b2b_terms_2_2_term'
  | 'b2b_terms_2_3_def'
  | 'b2b_terms_2_3_term'
  | 'b2b_terms_2_4_def'
  | 'b2b_terms_2_4_term'
  | 'b2b_terms_2_5_def'
  | 'b2b_terms_2_5_term'
  | 'b2b_terms_2_6_def'
  | 'b2b_terms_2_6_term'
  | 'b2b_terms_2_7_def'
  | 'b2b_terms_2_7_term'
  | 'b2b_terms_2_8_def'
  | 'b2b_terms_2_8_term'
  | 'b2b_terms_2_title'
  | 'b2b_terms_3_1_def'
  | 'b2b_terms_3_1_term'
  | 'b2b_terms_3_2_def'
  | 'b2b_terms_3_2_term'
  | 'b2b_terms_3_3_def'
  | 'b2b_terms_3_3_term'
  | 'b2b_terms_3_4_def'
  | 'b2b_terms_3_4_term'
  | 'b2b_terms_3_5_def'
  | 'b2b_terms_3_5_term'
  | 'b2b_terms_3_title'
  | 'b2b_terms_4_1_def'
  | 'b2b_terms_4_1_term'
  | 'b2b_terms_4_2_def'
  | 'b2b_terms_4_2_term'
  | 'b2b_terms_4_3_def'
  | 'b2b_terms_4_3_term'
  | 'b2b_terms_4_4_def'
  | 'b2b_terms_4_4_term'
  | 'b2b_terms_4_title'
  | 'b2b_terms_5_1_def'
  | 'b2b_terms_5_1_term'
  | 'b2b_terms_5_2_def'
  | 'b2b_terms_5_2_term'
  | 'b2b_terms_5_3_def'
  | 'b2b_terms_5_3_term'
  | 'b2b_terms_5_title'
  | 'b2b_terms_6_1_def'
  | 'b2b_terms_6_1_term'
  | 'b2b_terms_6_2_def'
  | 'b2b_terms_6_2_term'
  | 'b2b_terms_6_3_def'
  | 'b2b_terms_6_3_term'
  | 'b2b_terms_6_title'
  | 'b2b_terms_7_1_def'
  | 'b2b_terms_7_1_term'
  | 'b2b_terms_7_2_def'
  | 'b2b_terms_7_2_term'
  | 'b2b_terms_7_title'
  | 'b2b_terms_8_1_def'
  | 'b2b_terms_8_1_term'
  | 'b2b_terms_8_2_def'
  | 'b2b_terms_8_2_term'
  | 'b2b_terms_8_3_def'
  | 'b2b_terms_8_3_term'
  | 'b2b_terms_8_4_def'
  | 'b2b_terms_8_4_term'
  | 'b2b_terms_8_5_def'
  | 'b2b_terms_8_5_term'
  | 'b2b_terms_8_title'
  | 'b2b_terms_9_1_def'
  | 'b2b_terms_9_1_term'
  | 'b2b_terms_9_10_def'
  | 'b2b_terms_9_10_term'
  | 'b2b_terms_9_11_def'
  | 'b2b_terms_9_11_term'
  | 'b2b_terms_9_12_def'
  | 'b2b_terms_9_12_term'
  | 'b2b_terms_9_13_def'
  | 'b2b_terms_9_13_term'
  | 'b2b_terms_9_14_def'
  | 'b2b_terms_9_14_term'
  | 'b2b_terms_9_2_def'
  | 'b2b_terms_9_2_term'
  | 'b2b_terms_9_3_def'
  | 'b2b_terms_9_3_term'
  | 'b2b_terms_9_4_def'
  | 'b2b_terms_9_4_term'
  | 'b2b_terms_9_5_def'
  | 'b2b_terms_9_5_term'
  | 'b2b_terms_9_6_def'
  | 'b2b_terms_9_6_term'
  | 'b2b_terms_9_7_def'
  | 'b2b_terms_9_7_term'
  | 'b2b_terms_9_8_def'
  | 'b2b_terms_9_8_term'
  | 'b2b_terms_9_9_def'
  | 'b2b_terms_9_9_term'
  | 'b2b_terms_9_title'
  | 'b2b_terms_cs_additional_content'
  | 'b2b_terms_cs_additional_title'
  | 'b2b_terms_cs_checks_title'
  | 'b2b_terms_cs_intro'
  | 'b2b_terms_cs_meetings_list'
  | 'b2b_terms_cs_meetings_subtitle'
  | 'b2b_terms_cs_meetings_title'
  | 'b2b_terms_cs_page_title'
  | 'b2b_terms_cs_training_list'
  | 'b2b_terms_cs_training_title'
  | 'b2b_terms_intro_p1'
  | 'b2b_terms_intro_p2'
  | 'b2b_terms_intro_p3'
  | 'b2b_terms_intro_p4'
  | 'b2b_terms_last_updated'
  | 'b2b_terms_title'
  | 'b2b_terms_translation_disclaimer'
  | 'back'
  | 'back_to_list'
  | 'banner_accept_all'
  | 'banner_allow_all'
  | 'banner_consent_to_cookies'
  | 'banner_content'
  | 'banner_deny_all'
  | 'banner_message_refer_a_friend'
  | 'bedtime_approach_app_image_alt'
  | 'bedtime_approach_app_ui'
  | 'bedtime_approach_notification'
  | 'bedtime_approach_notification_image_alt'
  | 'bedtime_approach_notify_app_ui'
  | 'bedtime_guidance'
  | 'bedtime_guidance_body'
  | 'best_activity_tracker'
  | 'best_app_health_wellness'
  | 'best_buy'
  | 'best_buy_availability_by_location_failed'
  | 'best_buy_create_inventory_reservation_failed'
  | 'best_buy_get_nearby_stores_error'
  | 'best_buy_inventory_item_not_available'
  | 'best_buy_store_locator_legend_text'
  | 'best_buy_store_locator_subtitle'
  | 'best_buy_store_locator_subtitle_v2'
  | 'best_buy_store_locator_title'
  | 'best_buy_store_locator_title_v2'
  | 'best_buy_validate_pickup_email_invalid'
  | 'best_buy_validate_pickup_phone_invalid'
  | 'best_sleep_of_life'
  | 'best_sleep_tracker'
  | 'better_sleep_banner_cta'
  | 'better_sleep_banner_title'
  | 'betterhelp_campaign_message'
  | 'bf_distinct_styles_copy'
  | 'bf_dont_sleep_on_sale'
  | 'bfcm_2024_home_hero_cta'
  | 'bfcm_2024_home_hero_title'
  | 'bfcm_2024_menu_card_dyn_price_description'
  | 'bilbo_banner_message_tell_a_friend_onemonth'
  | 'bio'
  | 'black_friday_sale'
  | 'body_temp_app_ui'
  | 'body_temp_image_alt'
  | 'boxing_day_copy_2025'
  | 'boxing_day_sale'
  | 'braintree_cannot_authorize_policy'
  | 'braintree_declined_call_issuer'
  | 'braintree_funds_error'
  | 'braintree_gateway_rejected'
  | 'braintree_gateway_rejected_fraud'
  | 'braintree_invalid_merchant_id'
  | 'braintree_invalid_transaction'
  | 'braintree_limit_exceeded'
  | 'braintree_no_such_issuer'
  | 'braintree_processor_declined'
  | 'braintree_processor_declined_fraud_suspected'
  | 'breakage_from_drops'
  | 'bta_copy'
  | 'bta_heading'
  | 'bundle_cart_allringwarning'
  | 'bundle_cart_cancel'
  | 'bundle_cart_title'
  | 'bundle_cart_update'
  | 'bundle_cart_update_warranty'
  | 'bundle_cta_update_cart'
  | 'bundle_modal_one_year_subtitle'
  | 'bundle_modal_one_year_subtitle_hsa'
  | 'bundle_modal_one_year_title'
  | 'bundle_modal_skip_button'
  | 'bundle_modal_subtext'
  | 'bundle_modal_subtext_hsa_fsa'
  | 'bundle_modal_title'
  | 'bundle_modal_warranty_hsa_fsa'
  | 'bundle_modal_warranty_subtext_hsa_fsa'
  | 'bundle_modal_warranty_subtitle'
  | 'business_bring_to_work_action'
  | 'business_bring_to_work_description'
  | 'business_bring_to_work_header'
  | 'business_bring_to_work_icon_tag'
  | 'business_bring_to_work_title'
  | 'business_cards_athletics_description'
  | 'business_cards_athletics_title'
  | 'business_cards_business_sales_description'
  | 'business_cards_business_sales_title'
  | 'business_cards_government_description'
  | 'business_cards_government_title'
  | 'business_cards_health_care_description'
  | 'business_cards_health_care_title'
  | 'business_case_study_action'
  | 'business_case_study_quote'
  | 'business_case_study_title'
  | 'business_connect_modal_heading'
  | 'business_contact_us'
  | 'business_contact_us_action'
  | 'business_contact_us_description'
  | 'business_contact_us_title'
  | 'business_footer_survey_details'
  | 'business_gallery_bulk_order_action'
  | 'business_gallery_bulk_order_description'
  | 'business_gallery_bulk_order_title'
  | 'business_gallery_gift_card_action'
  | 'business_gallery_gift_card_description'
  | 'business_gallery_gift_card_title'
  | 'business_health_action'
  | 'business_health_title'
  | 'business_hero_action'
  | 'business_hero_alt'
  | 'business_hero_description'
  | 'business_hero_title'
  | 'business_how_we_can_help_description'
  | 'business_how_we_can_help_title'
  | 'business_human_performance_article_eyebrow'
  | 'business_human_performance_article_quote'
  | 'business_image_coffee_alt'
  | 'business_image_doctor_alt'
  | 'business_image_friends_alt'
  | 'business_image_government_alt'
  | 'business_image_gym_alt'
  | 'business_image_ipad_alt'
  | 'business_image_meeting_alt'
  | 'business_image_mudwtr_alt'
  | 'business_image_oura_app'
  | 'business_image_oura_app_alt'
  | 'business_image_sales_meeting_alt'
  | 'business_improved_data_bottom'
  | 'business_improved_data_middle'
  | 'business_improved_data_top'
  | 'business_improved_description'
  | 'business_improved_health_revised_title'
  | 'business_improved_title'
  | 'business_industry_description'
  | 'business_industry_title'
  | 'business_menu_employee_hpr'
  | 'business_menu_employee_wellness'
  | 'business_menu_gifting_and_rewards'
  | 'business_menu_research'
  | 'business_offerings_description_1'
  | 'business_offerings_description_2'
  | 'business_offerings_description_3'
  | 'business_offerings_header'
  | 'business_offerings_title_1'
  | 'business_offerings_title_2'
  | 'business_offerings_title_3'
  | 'button_placeholder'
  | 'buy'
  | 'buy_with_confidence_bg_alt'
  | 'buy_with_confidence_title'
  | 'CA_region_AB'
  | 'CA_region_BC'
  | 'CA_region_MB'
  | 'CA_region_NB'
  | 'CA_region_NL'
  | 'CA_region_NS'
  | 'CA_region_NT'
  | 'CA_region_NU'
  | 'CA_region_ON'
  | 'CA_region_PE'
  | 'CA_region_QC'
  | 'CA_region_SK'
  | 'CA_region_YT'
  | 'call_to_action_button_text'
  | 'canada_and_the_uk'
  | 'cancel_order'
  | 'cancel_order_confirmation'
  | 'cancel_order_no'
  | 'cancel_order_yes'
  | 'cardio_age_app_ui_alt'
  | 'cardio_cap_app_ui_alt'
  | 'cardio-capacity'
  | 'cardiovascular-age'
  | 'career_intro_hero_v2_alt'
  | 'careers_at_oura'
  | 'careers_filter_europe'
  | 'careers_filter_north_america'
  | 'careers_filter_view_all'
  | 'carousel_current_slide_label'
  | 'carousel_live_region_text'
  | 'carousel_next_slide_label'
  | 'carousel_page_dot_label'
  | 'carousel_previous_slide_label'
  | 'cart'
  | 'cart_add'
  | 'cart_addons_nc_content_1_description'
  | 'cart_addons_nc_content_1_title'
  | 'cart_addons_nc_content_2_description'
  | 'cart_addons_nc_content_2_title'
  | 'cart_addons_nc_content_3_description'
  | 'cart_addons_nc_content_3_title'
  | 'cart_addons_nc_free_title'
  | 'cart_addons_nc_heading_description'
  | 'cart_addons_nc_heading_title'
  | 'cart_addons_nc_hero_description'
  | 'cart_addons_nc_hero_src'
  | 'cart_addons_nc_hero_title'
  | 'cart_addons_nc_offer_description'
  | 'cart_addons_nc_offer_description_dynamic'
  | 'cart_addons_nc_offer_title'
  | 'cart_continue_shopping'
  | 'cart_count_sr_label'
  | 'cart_delayed_shipment_brushed_titanium'
  | 'cart_duties_message'
  | 'cart_extended_warranty_hsa_fsa_message'
  | 'cart_free'
  | 'cart_free_shipping_message'
  | 'cart_free_shipping_usd_message'
  | 'cart_full_charger_limit'
  | 'cart_full_ring_limit'
  | 'cart_is_full'
  | 'cart_max_chargers_per_order'
  | 'cart_max_rings_max_chargers_per_order'
  | 'cart_max_rings_one_charger_per_order'
  | 'cart_max_rings_per_order'
  | 'cart_noitems'
  | 'cart_one_charger_per_order'
  | 'cart_one_item_per_order'
  | 'cart_one_ring_max_chargers_per_order'
  | 'cart_one_ring_one_charger_per_order'
  | 'cart_product_description_finish'
  | 'cart_product_description_style'
  | 'cart_remove'
  | 'cart_shipping'
  | 'cart_shipping_message'
  | 'cart_shopnow'
  | 'cart_subscription_item_description_onemonth'
  | 'cart_subscription_multi_description_onemonth'
  | 'cart_summary_dexcom_stelo_terms'
  | 'cart_summary_dexcom_stelo_terms_05_2025'
  | 'cart_summary_dexcom_stelo_terms_06_2025'
  | 'cart_summary_nc_terms'
  | 'cart_tax'
  | 'cart_usd_message'
  | 'cart_vat'
  | 'case_studies_ucsd'
  | 'case_studies_ucsf'
  | 'case_studies_west_virginia'
  | 'ceramic_care_kit'
  | 'ceramic_care_kit_description'
  | 'ceramic_hero_alt'
  | 'ceramic_or4_alt'
  | 'certified_oura_advisor_female'
  | 'certified_oura_advisor_male'
  | 'changes_to_this_policy'
  | 'charger'
  | 'charger_included'
  | 'charger_set_gen_3'
  | 'charger_set_gen_3_title'
  | 'charger_set_gen_4_title'
  | 'charger_wizard_modal_gen3_heritage'
  | 'charger_wizard_modal_gen3_heritage_description'
  | 'charger_wizard_modal_gen3_horizon'
  | 'charger_wizard_modal_gen3_horizon_description'
  | 'charger_wizard_modal_gen4_description'
  | 'charger_wizard_modal_subtitle'
  | 'charger_wizard_modal_title'
  | 'chargers'
  | 'chatbot_button_text'
  | 'chatbot_initial_message_homepage'
  | 'chatbot_initial_message_or4_pdp'
  | 'chatbot_initial_message_or4_pop'
  | 'chatbot_input_placeholder'
  | 'chatbot_open'
  | 'chatbot_title'
  | 'checkout'
  | 'checkout_3ds_error_failure'
  | 'checkout_additional_details_warranty'
  | 'checkout_address_custom_validation_error'
  | 'checkout_address_error_city'
  | 'checkout_address_error_line1'
  | 'checkout_address_error_line2'
  | 'checkout_address_error_postal'
  | 'checkout_address_error_state'
  | 'checkout_affirm_content'
  | 'checkout_affirm_failed'
  | 'checkout_affirm_loading'
  | 'checkout_agreement'
  | 'checkout_api_error'
  | 'checkout_api_error_nexus'
  | 'checkout_api_error_region'
  | 'checkout_api_error_tax_missing_fields'
  | 'checkout_api_error_tax_unexpected_error'
  | 'checkout_api_error_taxpostalcode'
  | 'checkout_billingaddress'
  | 'checkout_calculate_invalid_sku_error'
  | 'checkout_calculate_lineitems_exception'
  | 'checkout_calculate_shipping_country_exception'
  | 'checkout_calculate_shippingrate_exception'
  | 'checkout_calculate_tax_breakdown_error'
  | 'checkout_currency_change'
  | 'checkout_delivery_address_complete_description'
  | 'checkout_delivery_address_edit_description'
  | 'checkout_delivery_options'
  | 'checkout_delivery_same_as_billing'
  | 'checkout_deliveryaddress'
  | 'checkout_email_agreement'
  | 'checkout_email_token_error'
  | 'checkout_error_general'
  | 'checkout_error_invalid_address'
  | 'checkout_error_invalid_cvv'
  | 'checkout_error_invalid_expiration'
  | 'checkout_error_invalid_number'
  | 'checkout_error_missing_fields'
  | 'checkout_error_onrecoverable'
  | 'checkout_form_100characters'
  | 'checkout_form_15characters'
  | 'checkout_form_22characters'
  | 'checkout_form_2characters'
  | 'checkout_form_30characters'
  | 'checkout_form_32characters'
  | 'checkout_form_40characters'
  | 'checkout_form_80characters'
  | 'checkout_form_83characters'
  | 'checkout_form_address'
  | 'checkout_form_address_required'
  | 'checkout_form_address2'
  | 'checkout_form_apartment'
  | 'checkout_form_cardholder_name'
  | 'checkout_form_cardnumber'
  | 'checkout_form_city'
  | 'checkout_form_city_required'
  | 'checkout_form_company'
  | 'checkout_form_country'
  | 'checkout_form_country_required'
  | 'checkout_form_cvv'
  | 'checkout_form_email'
  | 'checkout_form_email_confirm'
  | 'checkout_form_email_gift_buyer'
  | 'checkout_form_email_match'
  | 'checkout_form_emailcharacters'
  | 'checkout_form_emailerror'
  | 'checkout_form_emailformat'
  | 'checkout_form_emailformat_custom'
  | 'checkout_form_emailrequired'
  | 'checkout_form_expiration_date'
  | 'checkout_form_expirationmonth'
  | 'checkout_form_expirationyear'
  | 'checkout_form_firstname'
  | 'checkout_form_firstname_required'
  | 'checkout_form_gift'
  | 'checkout_form_gift_single_ring_only'
  | 'checkout_form_lastname'
  | 'checkout_form_lastname_required'
  | 'checkout_form_phone'
  | 'checkout_form_phone_required'
  | 'checkout_form_phoneinvalid'
  | 'checkout_form_postal_code_pattern'
  | 'checkout_form_postal_code_string'
  | 'checkout_form_postal_required'
  | 'checkout_form_recipient'
  | 'checkout_form_recipients_address'
  | 'checkout_form_recipients_city'
  | 'checkout_form_recipients_company'
  | 'checkout_form_recipients_country'
  | 'checkout_form_recipients_email'
  | 'checkout_form_recipients_email_confirm'
  | 'checkout_form_recipients_firstname'
  | 'checkout_form_recipients_lastname'
  | 'checkout_form_recipients_phone'
  | 'checkout_form_recipients_state'
  | 'checkout_form_recipients_vat_number'
  | 'checkout_form_recipients_zip'
  | 'checkout_form_required'
  | 'checkout_form_state'
  | 'checkout_form_state_required'
  | 'checkout_form_store_required'
  | 'checkout_form_vat'
  | 'checkout_form_vat_number'
  | 'checkout_form_zip'
  | 'checkout_fsa_hsa_cards'
  | 'checkout_fulfillment_method_best_buy_label'
  | 'checkout_fulfillment_method_delivery_label'
  | 'checkout_generic_error'
  | 'checkout_get_country_error'
  | 'checkout_gift_order_message'
  | 'checkout_hardware_payment_only_disclaimer'
  | 'checkout_hsafsa_warranty_message'
  | 'checkout_hsafsa_warranty_message_updated'
  | 'checkout_hsafsa_warranty_title'
  | 'checkout_hsafsa_warranty_title_updated'
  | 'checkout_input_click_to_show_label'
  | 'checkout_items_not_allowed'
  | 'checkout_ledger_balance_due'
  | 'checkout_ledger_gift_cards_total'
  | 'checkout_map_link'
  | 'checkout_missingcountry_error'
  | 'checkout_modal_no_pickup_care_kit'
  | 'checkout_modal_no_pickup_description'
  | 'checkout_modal_no_pickup_title'
  | 'checkout_modal_unavailable_description'
  | 'checkout_modal_unavailable_title'
  | 'checkout_no_additional_taxes_or_fees'
  | 'checkout_no_shipping_methods'
  | 'checkout_order_table_total'
  | 'checkout_payment'
  | 'checkout_payment_3ds_error'
  | 'checkout_payment_authentication_error'
  | 'checkout_payment_bank_rejected'
  | 'checkout_payment_duplicate_transaction_error'
  | 'checkout_payment_error'
  | 'checkout_payment_expired_card_error'
  | 'checkout_payment_fsa_hsa_attempted'
  | 'checkout_payment_funds_error'
  | 'checkout_payment_generic_error'
  | 'checkout_payment_invalid_card_error'
  | 'checkout_payment_invalid_cvv_error'
  | 'checkout_payment_invalid_date'
  | 'checkout_payment_limit_exceeded_error'
  | 'checkout_payment_max_attempts'
  | 'checkout_payment_method_label'
  | 'checkout_payment_method_sika'
  | 'checkout_payment_try_again'
  | 'checkout_paypal_auth_notice'
  | 'checkout_paypal_auth_success'
  | 'checkout_paypal_error'
  | 'checkout_paypal_error_incomplete'
  | 'checkout_pickup_change_store'
  | 'checkout_pickup_details'
  | 'checkout_pickup_details_description'
  | 'checkout_pickup_details_heading_find_a_store'
  | 'checkout_pickup_details_plural_units_left'
  | 'checkout_pickup_details_ready_in_time'
  | 'checkout_pickup_details_single_unit_left'
  | 'checkout_pickup_store_selector_cta'
  | 'checkout_pickup_store_selector_heading'
  | 'checkout_placeorder'
  | 'checkout_placeorder_authorization_exception'
  | 'checkout_placeorder_capture_exception'
  | 'checkout_placeorder_cart_not_found_exception'
  | 'checkout_placeorder_discount_mismatch_exception'
  | 'checkout_placeorder_failed_cart_completed_checkout_error'
  | 'checkout_placeorder_fraud_blocklist_exception'
  | 'checkout_placeorder_fraud_check_exception'
  | 'checkout_placeorder_location_cart_disallowed_product'
  | 'checkout_placeorder_payment_rejected_exception'
  | 'checkout_placeorder_retry_limit_exception'
  | 'checkout_placeorder_shipping_country_not_found_exception'
  | 'checkout_placeorder_sika_payment_failed'
  | 'checkout_placeorder_total_mismatch_exception'
  | 'checkout_privacypolicy'
  | 'checkout_privacypolicy_link_text'
  | 'checkout_process_payment_error'
  | 'checkout_processing_order'
  | 'checkout_reimbursement_receipt'
  | 'checkout_returntocart'
  | 'checkout_shipping_method'
  | 'checkout_shipping_sizing_kit'
  | 'checkout_shippinginformation'
  | 'checkout_sika_error_order_session'
  | 'checkout_sika_prepurchase_notice'
  | 'checkout_summary'
  | 'checkout_summary_billing_address'
  | 'checkout_summary_lifetime_membership'
  | 'checkout_summary_lifetime_membership_terms'
  | 'checkout_summary_message_delays'
  | 'checkout_summary_nc_message'
  | 'checkout_summary_news'
  | 'checkout_summary_order_confirmation'
  | 'checkout_summary_order_details'
  | 'checkout_summary_phone'
  | 'checkout_summary_recipient'
  | 'checkout_summary_shipping_address'
  | 'checkout_summary_tellafriend_offer'
  | 'checkout_summary_trial_gift_membership'
  | 'checkout_summary_trial_membership'
  | 'checkout_termsandconditions'
  | 'checkout_termsandconditions_link_text'
  | 'checkout_therabody_email_agreement'
  | 'checkout_unavailable_error'
  | 'checkout_unexpected_error'
  | 'checkout_validate_params_exception'
  | 'checkout_validateaddress_get_country_error'
  | 'checkout_validateaddress_lineitem_exception'
  | 'chee_bio'
  | 'chee_title'
  | 'chief_legal_officer'
  | 'choose_size'
  | 'choose_your_fulfillment_method'
  | 'choose_your_oura_ring'
  | 'choose_your_oura_ring_4'
  | 'choose_your_shipping_method'
  | 'claim_free_trial'
  | 'cleaning_and_care'
  | 'cleaning_care_instructions_copy'
  | 'cleaning_care_instructions_title'
  | 'clinical_studies_image_alt'
  | 'close'
  | 'close_overlay_aria_label'
  | 'close_up_food_img_alt'
  | 'cloud'
  | 'clue_plus_cta'
  | 'clue_plus_description'
  | 'clue_plus_title'
  | 'cnbc_disruptor_list'
  | 'collapse_card_aria_label'
  | 'coming_soon'
  | 'common_email_address'
  | 'common_submit'
  | 'compare_models_modal_battery_jade_or4'
  | 'compare_models_modal_battery_or3'
  | 'compare_models_modal_battery_or4'
  | 'compare_models_modal_battery_th'
  | 'compare_models_modal_design_jade'
  | 'compare_models_modal_design_or3'
  | 'compare_models_modal_design_or4'
  | 'compare_models_modal_design_or4_v2'
  | 'compare_models_modal_design_th'
  | 'compare_models_modal_design_th_v2'
  | 'compare_models_modal_price_jade'
  | 'compare_models_modal_price_or4'
  | 'compare_models_modal_price_th'
  | 'compare_models_modal_sensing_or3'
  | 'compare_models_modal_sensing_or4'
  | 'compare_models_modal_sensing_th'
  | 'compare_models_modal_sizing_or3'
  | 'compare_models_modal_sizing_or4'
  | 'compare_models_modal_sizing_th'
  | 'compare_models_modal_style_th'
  | 'compare_models_modal_title'
  | 'compare_models_modal_title_v2'
  | 'compare_oura_ring_models'
  | 'compare_rings_cta'
  | 'comparison_slider_control_label'
  | 'comparisons_oura_title'
  | 'competitive_salary'
  | 'competitive_salary_and_equity'
  | 'complete_order'
  | 'confirm_ring_size'
  | 'confirm_your_size'
  | 'consent_manager_preferences_close'
  | 'contact_brand_partnership_body'
  | 'contact_brand_partnership_title'
  | 'contact_customer_support'
  | 'contact_customer_support_body'
  | 'contact_customer_support_title'
  | 'contact_location_address'
  | 'contact_location_info'
  | 'contact_location_other'
  | 'contact_section_1_heading'
  | 'contact_section_2_heading'
  | 'contact_title'
  | 'continue'
  | 'cookie_policy_changes_copy'
  | 'cookie_policy_consent_copy'
  | 'cookie_policy_consent_to_use'
  | 'cookie_policy_contact_us_copy'
  | 'cookie_policy_do_not_track_copy'
  | 'cookie_policy_intro_one'
  | 'cookie_policy_intro_three'
  | 'cookie_policy_intro_two'
  | 'cookie_policy_managing_cookies_copy_four'
  | 'cookie_policy_managing_cookies_copy_one'
  | 'cookie_policy_managing_cookies_copy_three'
  | 'cookie_policy_managing_cookies_copy_two'
  | 'cookie_policy_our_site_copy'
  | 'cookie_policy_private_rights_copy_one'
  | 'cookie_policy_private_rights_copy_two'
  | 'cookie_policy_title'
  | 'cookie_policy_types_copy_one'
  | 'cookie_policy_types_copy_two'
  | 'cookie_policy_types_list_four'
  | 'cookie_policy_types_list_one'
  | 'cookie_policy_types_list_three'
  | 'cookie_policy_types_list_title'
  | 'cookie_policy_types_list_two'
  | 'cookie_policy_what_cookies_are_copy'
  | 'cookie_policy_why_we_use_cookies_copy'
  | 'cookie_policy_why_we_use_cookies_list_five'
  | 'cookie_policy_why_we_use_cookies_list_four'
  | 'cookie_policy_why_we_use_cookies_list_one'
  | 'cookie_policy_why_we_use_cookies_list_seven'
  | 'cookie_policy_why_we_use_cookies_list_six'
  | 'cookie_policy_why_we_use_cookies_list_three'
  | 'cookie_policy_why_we_use_cookies_list_title'
  | 'cookie_policy_why_we_use_cookies_list_two'
  | 'cookie_title'
  | 'copyright_registrations'
  | 'copyright_registrations_list'
  | 'corp_gift_image_alt_text'
  | 'corporate_wellness'
  | 'country_AD'
  | 'country_AE'
  | 'country_AF'
  | 'country_AG'
  | 'country_AI'
  | 'country_AL'
  | 'country_AM'
  | 'country_AO'
  | 'country_AQ'
  | 'country_AR'
  | 'country_AS'
  | 'country_AT'
  | 'country_AU'
  | 'country_AW'
  | 'country_AX'
  | 'country_AZ'
  | 'country_BA'
  | 'country_BB'
  | 'country_BD'
  | 'country_BE'
  | 'country_BF'
  | 'country_BG'
  | 'country_BH'
  | 'country_BI'
  | 'country_BJ'
  | 'country_BL'
  | 'country_BM'
  | 'country_BN'
  | 'country_BO'
  | 'country_BQ'
  | 'country_BR'
  | 'country_BS'
  | 'country_BT'
  | 'country_BV'
  | 'country_BW'
  | 'country_BY'
  | 'country_BZ'
  | 'country_CA'
  | 'country_CC'
  | 'country_CD'
  | 'country_CF'
  | 'country_CG'
  | 'country_CH'
  | 'country_CI'
  | 'country_CK'
  | 'country_CL'
  | 'country_CM'
  | 'country_CN'
  | 'country_CO'
  | 'country_CR'
  | 'country_CU'
  | 'country_CV'
  | 'country_CW'
  | 'country_CX'
  | 'country_CY'
  | 'country_CZ'
  | 'country_DE'
  | 'country_DJ'
  | 'country_DK'
  | 'country_DM'
  | 'country_DO'
  | 'country_DZ'
  | 'country_EA'
  | 'country_EC'
  | 'country_EE'
  | 'country_EG'
  | 'country_EH'
  | 'country_ER'
  | 'country_error'
  | 'country_ES'
  | 'country_ET'
  | 'country_FI'
  | 'country_FJ'
  | 'country_FK'
  | 'country_FM'
  | 'country_FO'
  | 'country_FR'
  | 'country_GA'
  | 'country_GB'
  | 'country_GD'
  | 'country_GE'
  | 'country_GF'
  | 'country_GG'
  | 'country_GH'
  | 'country_GI'
  | 'country_GL'
  | 'country_GM'
  | 'country_GN'
  | 'country_GP'
  | 'country_GQ'
  | 'country_GR'
  | 'country_GS'
  | 'country_GT'
  | 'country_GU'
  | 'country_GW'
  | 'country_GY'
  | 'country_HK'
  | 'country_HM'
  | 'country_HN'
  | 'country_HR'
  | 'country_HT'
  | 'country_HU'
  | 'country_IC'
  | 'country_ID'
  | 'country_IE'
  | 'country_IL'
  | 'country_IM'
  | 'country_IN'
  | 'country_IO'
  | 'country_IQ'
  | 'country_IR'
  | 'country_IS'
  | 'country_IT'
  | 'country_JE'
  | 'country_JM'
  | 'country_JO'
  | 'country_JP'
  | 'country_KE'
  | 'country_KG'
  | 'country_KH'
  | 'country_KI'
  | 'country_KM'
  | 'country_KN'
  | 'country_KP'
  | 'country_KR'
  | 'country_KW'
  | 'country_KY'
  | 'country_KZ'
  | 'country_LA'
  | 'country_LB'
  | 'country_LC'
  | 'country_LI'
  | 'country_LK'
  | 'country_LR'
  | 'country_LS'
  | 'country_LT'
  | 'country_LU'
  | 'country_LV'
  | 'country_LY'
  | 'country_MA'
  | 'country_MC'
  | 'country_MD'
  | 'country_ME'
  | 'country_MF'
  | 'country_MG'
  | 'country_MH'
  | 'country_MK'
  | 'country_ML'
  | 'country_MM'
  | 'country_MN'
  | 'country_MO'
  | 'country_MP'
  | 'country_MQ'
  | 'country_MR'
  | 'country_MS'
  | 'country_MT'
  | 'country_MU'
  | 'country_MV'
  | 'country_MW'
  | 'country_MX'
  | 'country_MY'
  | 'country_MZ'
  | 'country_NA'
  | 'country_NC'
  | 'country_NE'
  | 'country_NF'
  | 'country_NG'
  | 'country_NI'
  | 'country_NL'
  | 'country_NO'
  | 'country_NP'
  | 'country_NR'
  | 'country_NU'
  | 'country_NZ'
  | 'country_OM'
  | 'country_PA'
  | 'country_PE'
  | 'country_PF'
  | 'country_PG'
  | 'country_PH'
  | 'country_PK'
  | 'country_PL'
  | 'country_PM'
  | 'country_PN'
  | 'country_PR'
  | 'country_PS'
  | 'country_PT'
  | 'country_PW'
  | 'country_PY'
  | 'country_QA'
  | 'country_RE'
  | 'country_RO'
  | 'country_RS'
  | 'country_RU'
  | 'country_RW'
  | 'country_SA'
  | 'country_SB'
  | 'country_SC'
  | 'country_SD'
  | 'country_SE'
  | 'country_SG'
  | 'country_SH'
  | 'country_SI'
  | 'country_SJ'
  | 'country_SK'
  | 'country_SL'
  | 'country_SM'
  | 'country_SN'
  | 'country_SO'
  | 'country_SR'
  | 'country_SS'
  | 'country_ST'
  | 'country_SV'
  | 'country_SX'
  | 'country_SY'
  | 'country_SZ'
  | 'country_TC'
  | 'country_TD'
  | 'country_TF'
  | 'country_TG'
  | 'country_TH'
  | 'country_TJ'
  | 'country_TK'
  | 'country_TL'
  | 'country_TM'
  | 'country_TN'
  | 'country_TO'
  | 'country_TR'
  | 'country_TT'
  | 'country_TV'
  | 'country_TW'
  | 'country_TZ'
  | 'country_UA'
  | 'country_UG'
  | 'country_UM'
  | 'country_US'
  | 'country_UY'
  | 'country_UZ'
  | 'country_VA'
  | 'country_VC'
  | 'country_VE'
  | 'country_VG'
  | 'country_VI'
  | 'country_VN'
  | 'country_VU'
  | 'country_WF'
  | 'country_WS'
  | 'country_XI'
  | 'country_XK'
  | 'country_YE'
  | 'country_YT'
  | 'country_ZA'
  | 'country_ZM'
  | 'country_ZW'
  | 'craft_film_video'
  | 'credit_card'
  | 'cumulative_stress_app_ui'
  | 'cumulative_stress_app_ui_alt'
  | 'cumulative_stress_feature_copy'
  | 'cumulative_stress_feature_title'
  | 'current_terms_and_conditions'
  | 'customer_responsibilities'
  | 'cycle_insights'
  | 'cycle_insights_app_image_alt'
  | 'cycle_insights_app_ui_img'
  | 'cycle_insights_copy'
  | 'cycle_tracking_app_ui'
  | 'd2c_women_cycle_insights_ui'
  | 'd2c_women_pregnancy_insights_ui'
  | 'daily_habit'
  | 'damage_and_battery'
  | 'data_and_communications'
  | 'daytime_heartrate_app_ui'
  | 'daytime_heartrate_image_alt'
  | 'daytime_stress_app_image_alt'
  | 'daytime_stress_app_ui'
  | 'daytime_stress_image_alt'
  | 'declaration_of_conformity'
  | 'declarations_of_conformity'
  | 'delivery_estimates'
  | 'delivery_estimates_modal_title'
  | 'design_copy'
  | 'design_hand_drafting_alt'
  | 'design_image_alt_1'
  | 'design_image_alt_2'
  | 'design_image_alt_3'
  | 'design_image_alt_4'
  | 'design_title'
  | 'details_and_faq'
  | 'deutsch_bio'
  | 'deutsch_title'
  | 'developer_hero_body'
  | 'developer_hero_cta'
  | 'developer_hero_title'
  | 'developer_integrate_title'
  | 'developer_ready_to_start'
  | 'developer_secondary_body'
  | 'developer_secondary_title'
  | 'developer_ways_integrate_alt_activity'
  | 'developer_ways_integrate_alt_readiness'
  | 'developer_ways_integrate_alt_reproductive_health'
  | 'developer_ways_integrate_alt_sleep'
  | 'developer_ways_integrate_copy_activity'
  | 'developer_ways_integrate_copy_platforms'
  | 'developer_ways_integrate_copy_readiness'
  | 'developer_ways_integrate_copy_reproductive_health'
  | 'developer_ways_integrate_copy_sleep'
  | 'developer_ways_integrate_src_activity'
  | 'developer_ways_integrate_src_readiness'
  | 'developer_ways_integrate_src_reproductive_health'
  | 'developer_ways_integrate_src_sleep'
  | 'developer_ways_integrate_title'
  | 'developer_ways_integrate_title_activity'
  | 'developer_ways_integrate_title_platforms'
  | 'developer_ways_integrate_title_readiness'
  | 'developer_ways_integrate_title_reproductive_health'
  | 'developer_ways_integrate_title_sleep'
  | 'dexcom_app_ui_alt_key'
  | 'dexcom_hero_alt'
  | 'dexcom_hero_alt_2'
  | 'dexcom_hero_chiclet_copy'
  | 'dexcom_hero_chiclet_copy-2'
  | 'dexcom_phone_feature_alt'
  | 'dexcom_trademarks_disclaimer'
  | 'dexcom-hero-copy'
  | 'dexcom-hero-copy-2'
  | 'dexcom-hero-title'
  | 'dexcom-hero-title-2'
  | 'disallow_tracking_for_category'
  | 'discount_message_black_friday_2022_early_access'
  | 'discover'
  | 'do_not_track'
  | 'do_not_track_policy'
  | 'drafting_design_alt'
  | 'drop_down_extra_charger'
  | 'drop_down_gift_card'
  | 'drop_down_oura_ring'
  | 'easy_to_reach_offices_finland'
  | 'edit'
  | 'electrical_damage'
  | 'eleni_jaswa'
  | 'elissa_epel'
  | 'email_validation_error'
  | 'empowering_our_community'
  | 'engaged_app_ui_src'
  | 'engaged_card_tag'
  | 'eop_back_to_home'
  | 'eop_faqs_title'
  | 'eop_get_code_button'
  | 'eop_get_started_button'
  | 'eop_hide_order_button'
  | 'eop_home_orders_no_address'
  | 'eop_home_orders_page_status_completed'
  | 'eop_home_orders_page_status_expired'
  | 'eop_home_orders_page_status_order_processing'
  | 'eop_home_orders_page_status_pending'
  | 'eop_home_orders_page_status_pending_selections'
  | 'eop_home_orders_page_title'
  | 'eop_home_orders_page_welcome'
  | 'eop_invalid_description'
  | 'eop_invalid_title'
  | 'eop_login_email_page_description'
  | 'eop_login_email_page_otp_sent_text'
  | 'eop_login_email_page_support_text'
  | 'eop_login_email_page_title'
  | 'eop_maintenance_description'
  | 'eop_maintenance_title'
  | 'eop_need_additional_help_text'
  | 'eop_need_additional_help_title'
  | 'eop_order_confirmation_additional_text'
  | 'eop_order_confirmation_cigna_faq'
  | 'eop_order_confirmation_our_mission'
  | 'eop_order_confirmation_page_message'
  | 'eop_order_confirmation_page_success_text'
  | 'eop_order_confirmation_page_title'
  | 'eop_order_email'
  | 'eop_order_hero_enroll_body'
  | 'eop_order_hero_enroll_button'
  | 'eop_order_hero_enroll_title'
  | 'eop_order_hero_start_body'
  | 'eop_order_hero_start_button'
  | 'eop_order_hero_start_title'
  | 'eop_order_multi_selections_page_title'
  | 'eop_order_number_text'
  | 'eop_order_selections_page_choose_finish'
  | 'eop_order_selections_page_choose_size'
  | 'eop_order_selections_page_choose_size_description'
  | 'eop_order_selections_page_modal_sizing_tip_choose_finger'
  | 'eop_order_selections_page_modal_sizing_tip_choose_finger_description'
  | 'eop_order_selections_page_modal_sizing_tip_test_fit'
  | 'eop_order_selections_page_modal_sizing_tip_test_fit_description_1'
  | 'eop_order_selections_page_modal_sizing_tip_test_fit_description_2'
  | 'eop_order_selections_page_modal_title'
  | 'eop_order_selections_page_review_order'
  | 'eop_order_selections_page_title'
  | 'eop_order_shippingaddress'
  | 'eop_otp_code_label'
  | 'eop_quantity_text'
  | 'eop_resend_code_button'
  | 'eop_review_all_rings'
  | 'eop_select_ring_button'
  | 'eop_select_rings_button'
  | 'eop_select_size_error'
  | 'eop_shipping_address_description'
  | 'eop_sizing_checkbox_label'
  | 'eop_sizing_description'
  | 'eop_sizing_title'
  | 'eop_start_order_button'
  | 'eop_use_my_account_note'
  | 'eop_view_order_button'
  | 'epel_bio'
  | 'epel_title'
  | 'equinox_campaign_message'
  | 'error_boundary_heading'
  | 'esc_modal_continue'
  | 'esc_modal_edit'
  | 'esc_modal_text'
  | 'eu_data_act_disclosures_intro'
  | 'eu_data_act_disclosures_s1_p1'
  | 'eu_data_act_disclosures_s1_title'
  | 'eu_data_act_disclosures_s2_p1'
  | 'eu_data_act_disclosures_s2_p2'
  | 'eu_data_act_disclosures_s2_title'
  | 'eu_data_act_disclosures_s3_p1'
  | 'eu_data_act_disclosures_s3_p2'
  | 'eu_data_act_disclosures_s3_p3'
  | 'eu_data_act_disclosures_s3_title'
  | 'eu_data_act_disclosures_s4_p1'
  | 'eu_data_act_disclosures_s4_p2'
  | 'eu_data_act_disclosures_s4_p3'
  | 'eu_data_act_disclosures_s4_p4_li1'
  | 'eu_data_act_disclosures_s4_p4_li2'
  | 'eu_data_act_disclosures_s4_p4_li3'
  | 'eu_data_act_disclosures_s4_title'
  | 'eu_data_act_disclosures_s5_p1'
  | 'eu_data_act_disclosures_s5_title'
  | 'eu_data_act_disclosures_s6_contact1'
  | 'eu_data_act_disclosures_s6_contact2'
  | 'eu_data_act_disclosures_s6_p1'
  | 'eu_data_act_disclosures_s6_title'
  | 'eu_data_act_disclosures_s7_p1'
  | 'eu_data_act_disclosures_s7_title'
  | 'eu_data_act_disclosures_s8_p1'
  | 'eu_data_act_disclosures_s8_title'
  | 'eu_data_act_disclosures_title'
  | 'eu_declaration_article_3_1_a_emf'
  | 'eu_declaration_article_3_1_a_safety'
  | 'eu_declaration_article_3_1_b_emc'
  | 'eu_declaration_article_3_2_radio'
  | 'eu_declaration_brand'
  | 'eu_declaration_conformity_with'
  | 'eu_declaration_declare'
  | 'eu_declaration_declare_products'
  | 'eu_declaration_directive_2011'
  | 'eu_declaration_directive_2014'
  | 'eu_declaration_equipment_charger'
  | 'eu_declaration_equipment_ring'
  | 'eu_declaration_following_standards'
  | 'eu_declaration_gen_3'
  | 'eu_declaration_gen_4'
  | 'eu_declaration_jyri_title'
  | 'eu_declaration_of_conformity'
  | 'eu_declaration_page_access'
  | 'eu_declaration_signed_behalf'
  | 'eu_declaration_type_OA11'
  | 'eu_declaration_type_OA12'
  | 'eu_declaration_we'
  | 'eu_declarations_of_conformity'
  | 'exchange'
  | 'exclusive'
  | 'exclusive_cap'
  | 'expand_card_aria_label'
  | 'expedited_shipping'
  | 'experience_activity_feature_1_src'
  | 'experience_activity_feature_2_src'
  | 'experience_activity_feature_3_src'
  | 'experience_relax_feature_1_src'
  | 'experience_relax_feature_2_src'
  | 'experience_relax_feature_3_src'
  | 'experience_rest_image_1_ui_src'
  | 'experience_rest_image_2_ui_src'
  | 'experience_sleep_feature_1_src'
  | 'experience_sleep_feature_2_src'
  | 'experience_sleep_feature_3_src'
  | 'experience_sleep_feature_4_src'
  | 'experience_sleep_icon_label'
  | 'experience_stress_feature_1_src'
  | 'experience_stress_feature_2_src'
  | 'experience_style_image_1_alt'
  | 'explore'
  | 'explore_activity_score_copy'
  | 'explore_automatic_detection_copy'
  | 'explore_features'
  | 'explore_how_it_works_link'
  | 'explore_image_alt_1'
  | 'explore_image_alt_4'
  | 'explore_oura_collection'
  | 'explore_oura_ring_4'
  | 'explore_personalized_goals_copy'
  | 'explore_whats_possible_eyebrow'
  | 'explore_why_oura_link'
  | 'export_compliance_and_use_restrictions'
  | 'express_checkout'
  | 'express_checkout_terms'
  | 'express_checkout_terms_eu'
  | 'ext_checkout_error_stop'
  | 'ext_checkout_error_try_again'
  | 'extend'
  | 'extend_app_screen_alt'
  | 'extend_hero_subtitle'
  | 'extend_hero_title'
  | 'extend_messaging_alt'
  | 'extend_protection_header'
  | 'extend_section_header_10'
  | 'extend_section_header_11'
  | 'extend_section_header_12'
  | 'extend_section_header_13'
  | 'extend_section_header_14'
  | 'extend_section_header_15'
  | 'extend_section_header_16'
  | 'extend_section_header_17'
  | 'extend_section_header_18'
  | 'extend_section_header_19'
  | 'extend_section_header2'
  | 'extend_section_header3'
  | 'extend_section_header4'
  | 'extend_section_header5'
  | 'extend_section_header6'
  | 'extend_section_header7'
  | 'extend_section_header8'
  | 'extend_section_header9'
  | 'extend_section_one_description'
  | 'extend_section_one_title'
  | 'extend_section_three_description'
  | 'extend_section_three_title'
  | 'extend_section_two_description'
  | 'extend_section_two_title'
  | 'extend_trademark_alt'
  | 'extended_warranty_us_only'
  | 'extended_warranty_us_only_caption'
  | 'eyebrow_placeholder'
  | 'facebook'
  | 'family_table_img_alt'
  | 'fashionista_body'
  | 'fashionista_title'
  | 'fast_shipping'
  | 'fast_shipping_subcopy'
  | 'fathers_day_2025_eyebrow'
  | 'fcc_compliance_link'
  | 'fcc_sdoc_copy'
  | 'fcc_sdoc_footer_one'
  | 'fcc_sdoc_footer_three'
  | 'fcc_sdoc_footer_two'
  | 'fcc_sdoc_index_copy'
  | 'fcc_sdoc_index_title'
  | 'fcc_sdoc_nav_header'
  | 'fcc_sdoc_oa11'
  | 'fcc_sdoc_oa12'
  | 'fcc_sdoc_oura'
  | 'fcc_sdoc_party'
  | 'fcc_sdoc_title'
  | 'feature_article_title'
  | 'featured_article_tag'
  | 'features'
  | 'features_copy'
  | 'features_eyebrow'
  | 'features_tab_1_label'
  | 'features_tab_1_quote'
  | 'features_tab_2_label'
  | 'features_tab_3_label'
  | 'features_tab_3_quote'
  | 'features_tab_4_label'
  | 'features_tab_4_quote'
  | 'features_tab_5_label'
  | 'features_title'
  | 'february_2024'
  | 'federal_government_end_use_restrictions'
  | 'felicity_v_alt'
  | 'felicity_v_quote'
  | 'fertile_window_app_ui_img'
  | 'fertile_window_copy'
  | 'fertile_window_image_alt'
  | 'fertile_window_title'
  | 'fertility_benefits'
  | 'fitness'
  | 'fitness_fanatics_body'
  | 'fitness_fanatics_title'
  | 'fitness_features_heart_rate_description'
  | 'fitness_features_sleep_lab_title'
  | 'fitness_goals_focus'
  | 'fitness_hero_sub_title_landing'
  | 'fitness_press_press_img_atl'
  | 'fitness_tag'
  | 'flash_sale'
  | 'flexible_financing'
  | 'flexible_hours'
  | 'flexible_payment_options'
  | 'flexible_spending_footer_link'
  | 'flexible_working_hours_and_worklife_balance'
  | 'floating_bar_oura_ring_4_ceramic'
  | 'food_camera_img_alt'
  | 'footer_about_us'
  | 'footer_accessibility'
  | 'footer_all_rights_reserved'
  | 'footer_articles_aria_forbes'
  | 'footer_articles_aria_oprah_daily'
  | 'footer_articles_aria_time'
  | 'footer_blog_heading'
  | 'footer_careers'
  | 'footer_company_heading'
  | 'footer_connect'
  | 'footer_contact'
  | 'footer_copyright'
  | 'footer_dataprotect_1'
  | 'footer_dataprotect_privacy_policy'
  | 'footer_developers'
  | 'footer_email'
  | 'footer_email_input_heading'
  | 'footer_email_validation_error'
  | 'footer_help'
  | 'footer_image_cta'
  | 'footer_ip_notice'
  | 'footer_leadership'
  | 'footer_legal_aria_label'
  | 'footer_legal_link_v4'
  | 'footer_medical_advisory_board'
  | 'footer_membership'
  | 'footer_my_account'
  | 'footer_newsletter_submit_label'
  | 'footer_oura_on_the_web'
  | 'footer_partner_heading'
  | 'footer_press'
  | 'footer_press_section_hero'
  | 'footer_press_section_right_1'
  | 'footer_press_section_right_2'
  | 'footer_press_section_right_3'
  | 'footer_privacy_policy'
  | 'footer_pulse_blog'
  | 'footer_security_center'
  | 'footer_sizing'
  | 'footer_social_heading'
  | 'footer_social_icons_aria_label'
  | 'footer_support_heading'
  | 'footer_terms_and_conditions'
  | 'footer_thanks_for_subscribing'
  | 'footnote_affirm'
  | 'footnote_battery'
  | 'footnote_heart_rate_hrv_accuracy_source'
  | 'footnote_personal_baseline'
  | 'footnote_smart_sensing_source'
  | 'footnote_warranty'
  | 'footnotes_battery_ourashop_1'
  | 'footnotes_membership_pricing'
  | 'footnotes_membership_pricing_updated'
  | 'footnotes_nc_ourashop_2'
  | 'for_business_link'
  | 'for_organizations'
  | 'for_the_ones_you_love'
  | 'free'
  | 'free_2_day_shipping'
  | 'free_easy_returns'
  | 'free_easy_returns_subcopy'
  | 'free_shipping'
  | 'free_shipping_for_replacement'
  | 'free_shipping_row'
  | 'free_shipping_usa'
  | 'free_sizing_kit'
  | 'free_standard_shipping'
  | 'free_trial_month'
  | 'free_trial_month_subcopy'
  | 'frequent_travelers_body'
  | 'frequent_travelers_title'
  | 'from'
  | 'frontpage_learn_more'
  | 'fulfillment_method_description'
  | 'fully_titanium_design'
  | 'gen_3'
  | 'gen3_holiday_hero_copy_2025'
  | 'gen3_special_pricing'
  | 'gen4_hero_cta'
  | 'gen4_is_here'
  | 'gift_cards_apply_title'
  | 'gift_cards_button_remove'
  | 'gift_cards_button_submit'
  | 'gift_cards_card_number'
  | 'gift_cards_chiclet_copy'
  | 'gift_cards_chiclet_img_alt'
  | 'gift_cards_error_invalid_card'
  | 'gift_cards_error_invalid_currency'
  | 'gift_cards_error_no_balance'
  | 'gift_cards_error_unexpected'
  | 'gift_cards_payment_method_notice'
  | 'gift_cards_pin_number'
  | 'gift_email_description'
  | 'gift_hero_title'
  | 'gift_message'
  | 'gift_message_description'
  | 'gift_message_label'
  | 'gift_of_good_health_body'
  | 'gift_of_good_health_title'
  | 'gift_options'
  | 'gift-card-balance-copy'
  | 'gift-card-balance-cta'
  | 'gift-card-balance-header'
  | 'gift-card-bullet-1'
  | 'gift-card-bullet-2'
  | 'gift-card-bullet-3'
  | 'gift-card-corporate-purchase-copy'
  | 'gift-card-corporate-purchase-cta'
  | 'gift-card-corporate-purchase-header'
  | 'gift-card-purchase-cta'
  | 'gift-card-purchase-header'
  | 'gift-card-sr-header'
  | 'gifting_and_events'
  | 'gifting_chiclet_2025'
  | 'gifting_hero_description_2025'
  | 'gifting_hero_title_2025'
  | 'gifting-fitness-fanatics-image'
  | 'gifting-frequent-travelers-app-ui'
  | 'gifting-frequent-travelers-image'
  | 'gifting-nap-taker-image'
  | 'gifting-nightowls-earlybirds-image'
  | 'gifting-sleep-trends-app-ui'
  | 'gifting-sleep-trends-mock-image'
  | 'gifting-starting-out-activity-image'
  | 'good'
  | 'google_pay'
  | 'gottfried_bio'
  | 'governing_law_class_action_waiver'
  | 'ground_shipping_method_standard'
  | 'grow-1838-activity-auto-activity-desc'
  | 'grow-1838-activity-personalized-img-src'
  | 'grow-1838-activity-score-desc'
  | 'grow-1838-heart-health-cardio-age-app-ui-src'
  | 'grow-1838-heart-health-cardio-age-desc'
  | 'grow-1838-heart-health-cardio-cap-app-ui-src'
  | 'grow-1838-heart-health-cardio-capacity-desc'
  | 'grow-1838-personalized-activity-goals-desc'
  | 'grow-1838-stress-daytime-desc'
  | 'grow-1838-stress-resilience-desc'
  | 'grow-1838-womens-health-period-prediction-desc'
  | 'grow-2045-nc-oc-copy'
  | 'guidelines_for_commercial_use_content'
  | 'guidelines_for_commercial_use_title'
  | 'gutf_chiclet_img_alt'
  | 'gutf_hero_chiclet_copy'
  | 'gutf_hero_copy'
  | 'gutf_hero_img_alt'
  | 'gutf_hero_title'
  | 'hand_holding_bag_alt'
  | 'hand_pocket_img_alt'
  | 'hcaptcha_footer_legalese'
  | 'header_hamburger_close_sr_label'
  | 'header_hamburger_close_sr_label_2024'
  | 'header_hamburger_open_sr_label'
  | 'header_hamburger_open_sr_label_2024'
  | 'header_how_it_works_image_app_ui'
  | 'header_shop_label_preorder'
  | 'header_shop_now'
  | 'header_skip_to_content'
  | 'health_dental_and_vision'
  | 'health_panels_description'
  | 'health_panels_image_alt'
  | 'health_panels_title'
  | 'healthcare'
  | 'heart_health'
  | 'heart_health_beverage_alt'
  | 'heart_health_cardio_age_app_ui'
  | 'heart_health_cardio_capacity_app_ui'
  | 'heart_health_chiclet_coming_soon'
  | 'heart_health_chiclet_now_here'
  | 'heart_health_family_alt'
  | 'heart_health_features_cardio_copy'
  | 'heart_health_features_cardio_heading'
  | 'heart_health_features_cva_copy'
  | 'heart_health_features_cva_heading'
  | 'heart_health_features_eyebrow'
  | 'heart_health_features_heart_rate_copy'
  | 'heart_health_features_hrv_copy'
  | 'heart_health_heart_rate_app_ui'
  | 'heart_health_hero_subtitle'
  | 'heart_health_hero_title'
  | 'heart_health_hero_title_2024'
  | 'heart_health_hrv_app_ui'
  | 'heart_health_integrations_apple'
  | 'heart_health_integrations_description'
  | 'heart_health_integrations_google'
  | 'heart_health_link'
  | 'heart_health_man_closeup_alt'
  | 'heart_health_press_featured_heading'
  | 'heart_health_press_item_1'
  | 'heart_health_press_item_2'
  | 'heart_health_press_item_3'
  | 'heart_health_tag'
  | 'heart_health_testimonial_quote_anne'
  | 'heart_health_testimonial_quote_dave_k'
  | 'heart_health_testimonial_quote_ted_n'
  | 'heart_health_testimonials_description'
  | 'heart_health_testimonials_eyebrow'
  | 'heart_rate_app_image_alt'
  | 'heart_rate_app_ui'
  | 'heart_rate_app_ui_2'
  | 'heart_rate_app_ui_alt'
  | 'heart_rate_image_2_alt'
  | 'heart_rate_monitoring'
  | 'heart_rate_monitoring_accuracy_description'
  | 'heart_rate_monitoring_accuracy_title'
  | 'heart_rate_monitoring_health_stats_description'
  | 'heart_rate_monitoring_health_stats_title'
  | 'heart_rate_monitoring_heart_rate_description'
  | 'heart_rate_monitoring_heart_rate_title'
  | 'heart_rate_monitoring_hrv_description'
  | 'heart_rate_monitoring_hrv_title'
  | 'heart_rate_monitoring_link'
  | 'heart_rate_monitoring_listitem_1'
  | 'heart_rate_monitoring_listitem_2'
  | 'heart_rate_monitoring_listitem_3'
  | 'heart_rate_monitoring_listitem_4'
  | 'heart_rate_monitoring_pricing_details'
  | 'heart_rate_monitoring_pricing_details_v2'
  | 'heart_rate_monitoring_research_title'
  | 'heart_rate_monitoring_slideshow_description'
  | 'heart_rate_monitoring_spo2_description'
  | 'heart_rate_monitoring_titanium_description'
  | 'heart_rate_monitoring_trends_description'
  | 'heart_rate_monitoring_uc_san_diego_alt'
  | 'heart_rate_monitoring_uc_san_diego_description'
  | 'heart_rate_monitoring_virginia_alt'
  | 'heart_rate_monitoring_virginia_description'
  | 'heart_rate_slide_4_alt'
  | 'heartrate_monitoring_pricing_note'
  | 'heartrate_monitoring_pricing_note_v2'
  | 'heli_k_job_title'
  | 'heli_quote'
  | 'hello_oura'
  | 'helsinki_and_oulu'
  | 'heritage_ring_slide_1_alt'
  | 'heritage_rings_slide_3_alt'
  | 'hero_chiclet_image_alt'
  | 'hero_spring_price_drop_subcopy'
  | 'hero_spring_price_drop_title'
  | 'hero_title_variant_one'
  | 'holding_hands_image_alt'
  | 'holiday_2024_hero_copy'
  | 'holiday_2024_hero_title'
  | 'holiday_at_checkout_gift'
  | 'holiday_customize_gift_message'
  | 'holiday_delight_everyone_on_your_list'
  | 'holiday_hero_title_2025'
  | 'holiday_let_them_choose'
  | 'holiday_row_tier_1_2025'
  | 'holiday_row_tier_2_2025'
  | 'holiday_smartest_gift_ever'
  | 'holiday_us_expedited_2025'
  | 'holiday_us_standard_2025'
  | 'home_awards_cnbc'
  | 'home_awards_cnbc_disruptor'
  | 'home_awards_pop_sugar'
  | 'home_awards_webby'
  | 'home_features_activity_ui'
  | 'home_features_heart_ui'
  | 'home_features_sleep_ui'
  | 'home_features_stress_ui'
  | 'home_features_wellness_ui'
  | 'home_features_womens_ui'
  | 'home_hero_chiclet'
  | 'home_image_scroller_image_1_alt'
  | 'home_image_scroller_image_3_alt'
  | 'home_page_app_ui_readiness'
  | 'home_scenarios_illness_radar_ui'
  | 'home_scenarios_illness_readiness_ui'
  | 'home_scenarios_party_hr_ui'
  | 'home_scenarios_party_stress_ui'
  | 'home_scenarios_sleep_chart_ui'
  | 'home_scenarios_sleep_readiness_ui'
  | 'home_scenarios_walk_hr_ui'
  | 'home_scenarios_walk_steps_ui'
  | 'home_scenarios_wind_down_ui'
  | 'homepage_press_article_1'
  | 'homepage_press_article_2'
  | 'homepage_press_article_2_chloe_aiello'
  | 'homepage_press_article_3'
  | 'homepage_press_article_3_axios'
  | 'homepage_press_hero_article'
  | 'homepage_press_hero_article_ai'
  | 'homepage_sleep_hsa_compliance_copy'
  | 'horizon_and_heritage_rings_alt'
  | 'horizon_free_shipping'
  | 'horizon_heritage_styles'
  | 'horizon_rings_slide_2_alt'
  | 'how_it_started'
  | 'how_it_works_10pm_copy'
  | 'how_it_works_10pm_title'
  | 'how_it_works_12pm_copy'
  | 'how_it_works_12pm_title'
  | 'how_it_works_3pm_copy'
  | 'how_it_works_3pm_title'
  | 'how_it_works_6am_copy'
  | 'how_it_works_6am_title'
  | 'how_it_works_6pm_copy'
  | 'how_it_works_6pm_title'
  | 'how_it_works_become_a_member_copy'
  | 'how_it_works_become_a_member_cta'
  | 'how_it_works_become_a_member_title'
  | 'how_it_works_hero_copy'
  | 'how_it_works_hero_copy_update_September_2025'
  | 'how_it_works_hero_eyebrow'
  | 'how_it_works_hero_title'
  | 'how_it_works_link'
  | 'how_it_works_timeline_10pm'
  | 'how_it_works_timeline_12pm'
  | 'how_it_works_timeline_3pm'
  | 'how_it_works_timeline_6am'
  | 'how_it_works_timeline_6pm'
  | 'how_oura_was_founded'
  | 'how_to_contact_us'
  | 'hra_copy'
  | 'hra_heading'
  | 'hrm_carousel_heart_rate_app_ui'
  | 'hrm_carousel_spo2_app_ui'
  | 'hrm_carousel_spo2_app_ui_summer25_update'
  | 'hrm_or4_ring_silver_slide_1_alt'
  | 'hrm_or4_rings_slide_2_alt'
  | 'hrv_app_ui_alt'
  | 'hrv_copy'
  | 'hrv_heading'
  | 'hsa_fsa_eligible'
  | 'hsa_fsa_eligible_copy'
  | 'hsa_fsa_eligible_line_item'
  | 'hsa_fsa_eligible_logo_inline_no_link'
  | 'hsa_fsa_eyebrow'
  | 'hsa_fsa_eyebrow_2025'
  | 'i_acknowledge'
  | 'if_design_award_alt'
  | 'illness_detection'
  | 'impressum_label_business_address'
  | 'impressum_label_business_name'
  | 'impressum_label_email_address'
  | 'impressum_label_phone_number'
  | 'impressum_label_registration_number'
  | 'impressum_label_vat_id_number'
  | 'impressum_page_title'
  | 'includes_oura_ring_4_ceramic'
  | 'includes_usb_cable_subcopy'
  | 'ins_outs_womens_health'
  | 'insights_copy'
  | 'insights_title'
  | 'instagram'
  | 'instant_checkout'
  | 'integration_app_card_headspace'
  | 'integration_app_card_natural_cycles'
  | 'integration_app_card_strava'
  | 'integrations_all_integrations_activity_and_performance_tab'
  | 'integrations_all_integrations_food_and_nutrition_tab'
  | 'integrations_all_integrations_mental_health_tab'
  | 'integrations_all_integrations_sleep_tab'
  | 'integrations_all_integrations_womens_health_tab'
  | 'integrations_app_name_headspace'
  | 'integrations_app_name_natural_cycles'
  | 'integrations_app_name_strava'
  | 'integrations_apple_health_kit'
  | 'integrations_apps_section_copy'
  | 'integrations_apps_section_eyebrow'
  | 'integrations_apps_section_title'
  | 'integrations_card_read_more'
  | 'integrations_cronometer_description'
  | 'integrations_footer_cta_copy'
  | 'integrations_footer_cta_copy_2'
  | 'integrations_footer_cta_img_alt'
  | 'integrations_footer_cta_link'
  | 'integrations_footer_cta_title'
  | 'integrations_google_health_connect'
  | 'integrations_headspace_card_img_alt'
  | 'integrations_headspace_description'
  | 'integrations_hero_alt_text'
  | 'integrations_hero_copy'
  | 'integrations_hero_eyebrow'
  | 'integrations_hero_title'
  | 'integrations_link'
  | 'integrations_myfitnesspal_description'
  | 'integrations_natural_cycles_card_img_alt'
  | 'integrations_natural_cycles_description'
  | 'integrations_privacy_section_copy'
  | 'integrations_privacy_section_title'
  | 'integrations_select_integrations_section_title'
  | 'integrations_strava_card_img_alt'
  | 'integrations_strava_description'
  | 'integrations_zero_description'
  | 'intellectual_property_rights'
  | 'intended_usage_acknowledgement'
  | 'introduction'
  | 'invalid_country_for_currency'
  | 'invalid_country_region'
  | 'invalid_shipping_country'
  | 'inventory_insights_finish_step_low_stock_msg'
  | 'inventory_insights_low_stock_shop_gen4'
  | 'inventory_insights_out_of_stock_shop_gen4'
  | 'inventory_low_stock_message'
  | 'inventory_notify_module_button'
  | 'inventory_notify_module_continue_shopping'
  | 'inventory_notify_module_exit_subtext'
  | 'inventory_notify_module_exit_title'
  | 'inventory_notify_module_form_title'
  | 'inventory_notify_module_get_notified'
  | 'inventory_notify_module_header'
  | 'inventory_notify_module_subtext'
  | 'inventory_out_of_stock_message'
  | 'ios_and_android_compatible'
  | 'ip_app_ui'
  | 'ip_brand_app_alt'
  | 'ip_brand_app_content'
  | 'ip_brand_app_icon_activity'
  | 'ip_brand_app_icon_battery'
  | 'ip_brand_app_icon_col_icons'
  | 'ip_brand_app_icon_col_use'
  | 'ip_brand_app_icon_crown'
  | 'ip_brand_app_icon_explore'
  | 'ip_brand_app_icon_lungs'
  | 'ip_brand_app_icon_meditation'
  | 'ip_brand_app_icon_moon'
  | 'ip_brand_app_icon_readiness'
  | 'ip_brand_app_icons'
  | 'ip_brand_app_title'
  | 'ip_brand_assets_content'
  | 'ip_brand_assets_title'
  | 'ip_brand_features_content'
  | 'ip_brand_features_heading'
  | 'ip_brand_ring_content'
  | 'ip_brand_ring_features_alt'
  | 'ip_brand_ring_title'
  | 'ip_brand_slogans_list'
  | 'ip_brand_slogans_title'
  | 'ip_brand_themes_content'
  | 'ip_brand_themes_palette_primary'
  | 'ip_brand_themes_palette_primary_black'
  | 'ip_brand_themes_palette_primary_blue'
  | 'ip_brand_themes_palette_primary_sandstone'
  | 'ip_brand_themes_palette_primary_white'
  | 'ip_brand_themes_palette_secondary'
  | 'ip_brand_themes_palette_secondary_blue'
  | 'ip_brand_themes_palette_secondary_coral'
  | 'ip_brand_themes_palette_secondary_sandstone'
  | 'ip_brand_themes_title'
  | 'ip_brand_trademarks_list'
  | 'ip_brand_trademarks_list_new'
  | 'ip_brand_trademarks_title'
  | 'ip_brand_web_content'
  | 'ip_brand_web_content_alt'
  | 'ip_brand_web_title'
  | 'ip_notice_intro'
  | 'ip_notice_title'
  | 'ip_patents_app_list'
  | 'ip_patents_app_list_07_2025'
  | 'ip_patents_app_title'
  | 'ip_patents_heading'
  | 'ip_patents_ring_list'
  | 'ip_patents_ring_list_07_2025'
  | 'ip_patents_ring_title'
  | 'ip_phone_app_ui'
  | 'ip_registered_trademarks_intro'
  | 'ip_registered_trademarks_list'
  | 'ip_registered_trademarks_title'
  | 'ip_trademarks_content'
  | 'ip_trademarks_heading'
  | 'IT_region_AG'
  | 'IT_region_AL'
  | 'IT_region_AN'
  | 'IT_region_AO'
  | 'IT_region_AP'
  | 'IT_region_AQ'
  | 'IT_region_AR'
  | 'IT_region_AT'
  | 'IT_region_AV'
  | 'IT_region_BA'
  | 'IT_region_BG'
  | 'IT_region_BI'
  | 'IT_region_BL'
  | 'IT_region_BN'
  | 'IT_region_BO'
  | 'IT_region_BR'
  | 'IT_region_BS'
  | 'IT_region_BT'
  | 'IT_region_BZ'
  | 'IT_region_CA'
  | 'IT_region_CB'
  | 'IT_region_CE'
  | 'IT_region_CH'
  | 'IT_region_CI'
  | 'IT_region_CL'
  | 'IT_region_CN'
  | 'IT_region_CO'
  | 'IT_region_CR'
  | 'IT_region_CS'
  | 'IT_region_CT'
  | 'IT_region_CZ'
  | 'IT_region_EN'
  | 'IT_region_FC'
  | 'IT_region_FE'
  | 'IT_region_FG'
  | 'IT_region_FI'
  | 'IT_region_FM'
  | 'IT_region_FR'
  | 'IT_region_GE'
  | 'IT_region_GO'
  | 'IT_region_GR'
  | 'IT_region_IM'
  | 'IT_region_IS'
  | 'IT_region_KR'
  | 'IT_region_LC'
  | 'IT_region_LE'
  | 'IT_region_LI'
  | 'IT_region_LO'
  | 'IT_region_LT'
  | 'IT_region_LU'
  | 'IT_region_MB'
  | 'IT_region_MC'
  | 'IT_region_ME'
  | 'IT_region_MI'
  | 'IT_region_MN'
  | 'IT_region_MO'
  | 'IT_region_MS'
  | 'IT_region_MT'
  | 'IT_region_NA'
  | 'IT_region_NO'
  | 'IT_region_NU'
  | 'IT_region_OG'
  | 'IT_region_OR'
  | 'IT_region_OT'
  | 'IT_region_PA'
  | 'IT_region_PC'
  | 'IT_region_PD'
  | 'IT_region_PE'
  | 'IT_region_PG'
  | 'IT_region_PI'
  | 'IT_region_PN'
  | 'IT_region_PO'
  | 'IT_region_PR'
  | 'IT_region_PT'
  | 'IT_region_PU'
  | 'IT_region_PV'
  | 'IT_region_PZ'
  | 'IT_region_RA'
  | 'IT_region_RC'
  | 'IT_region_RE'
  | 'IT_region_RG'
  | 'IT_region_RI'
  | 'IT_region_RM'
  | 'IT_region_RN'
  | 'IT_region_RO'
  | 'IT_region_SA'
  | 'IT_region_SI'
  | 'IT_region_SO'
  | 'IT_region_SP'
  | 'IT_region_SR'
  | 'IT_region_SS'
  | 'IT_region_SV'
  | 'IT_region_TA'
  | 'IT_region_TE'
  | 'IT_region_TN'
  | 'IT_region_TO'
  | 'IT_region_TP'
  | 'IT_region_TR'
  | 'IT_region_TS'
  | 'IT_region_TV'
  | 'IT_region_UD'
  | 'IT_region_VA'
  | 'IT_region_VB'
  | 'IT_region_VC'
  | 'IT_region_VE'
  | 'IT_region_VI'
  | 'IT_region_VR'
  | 'IT_region_VS'
  | 'IT_region_VT'
  | 'IT_region_VV'
  | 'jade_advanced_battery_copy'
  | 'jade_advanced_header'
  | 'jade_advanced_technology_copy'
  | 'jade_assortment_image_alt'
  | 'jade_built_to_last_copy'
  | 'jade_ceramic_picker_button_alt'
  | 'jade_cloud_copy'
  | 'jade_cloud_product_img_alt'
  | 'jade_colorful_life_header'
  | 'jade_discover_ceramic'
  | 'jade_features_header'
  | 'jade_home_hero_title'
  | 'jade_intro_2_copy'
  | 'jade_intro_copy'
  | 'jade_intro_header'
  | 'jade_live_in_color'
  | 'jade_midnight_copy'
  | 'jade_midnight_product_img_alt'
  | 'jade_pdp_cloud_primary_image_alt'
  | 'jade_pdp_faq_2_answer'
  | 'jade_pdp_faq_2_question'
  | 'jade_pdp_faq_3_answer'
  | 'jade_pdp_faq_3_question'
  | 'jade_pdp_faq_4_answer'
  | 'jade_pdp_faq_4_question'
  | 'jade_pdp_faq_5_question'
  | 'jade_pdp_hardware_card_1_alt'
  | 'jade_pdp_hardware_card_1_copy'
  | 'jade_pdp_hardware_card_1_title'
  | 'jade_pdp_hardware_card_2_alt'
  | 'jade_pdp_hardware_card_2_copy'
  | 'jade_pdp_hardware_card_2_title'
  | 'jade_pdp_hardware_card_3_alt'
  | 'jade_pdp_hardware_card_3_copy'
  | 'jade_pdp_hardware_card_3_title'
  | 'jade_pdp_hardware_section_title'
  | 'jade_pdp_hero_subtitle'
  | 'jade_pdp_membership_img_src'
  | 'jade_pdp_membership_section_copy'
  | 'jade_pdp_membership_section_image_alt'
  | 'jade_pdp_membership_section_image_src'
  | 'jade_pdp_membership_section_title'
  | 'jade_pdp_midnight_primary_image_alt'
  | 'jade_pdp_petal_primary_image_alt'
  | 'jade_pdp_tide_primary_image_alt'
  | 'jade_person_wearing_cloud_alt'
  | 'jade_person_wearing_midnight_alt'
  | 'jade_person_wearing_petal_alt'
  | 'jade_person_wearing_tide_alt'
  | 'jade_petal_copy'
  | 'jade_petal_product_img_alt'
  | 'jade_pop_built_to_last_bg_alt'
  | 'jade_tech_specs_dimensions_list'
  | 'jade_tech_specs_included_image_alt'
  | 'jade_tech_specs_included_list'
  | 'jade_tech_specs_included_list_no_care_kit'
  | 'jade_tech_specs_quality_materials_list'
  | 'jade_tech_specs_sensors_list'
  | 'jade_tech_specs_whats_included_list'
  | 'jade_tide_copy'
  | 'jade_tide_product_img_alt'
  | 'jade_tide_reflection_img_alt'
  | 'jagmeet_singh'
  | 'jake_deutsch'
  | 'jaswa_bio'
  | 'jaswa_title'
  | 'jcb'
  | 'JP_region_JP-01'
  | 'JP_region_JP-02'
  | 'JP_region_JP-03'
  | 'JP_region_JP-04'
  | 'JP_region_JP-05'
  | 'JP_region_JP-06'
  | 'JP_region_JP-07'
  | 'JP_region_JP-08'
  | 'JP_region_JP-09'
  | 'JP_region_JP-10'
  | 'JP_region_JP-11'
  | 'JP_region_JP-12'
  | 'JP_region_JP-13'
  | 'JP_region_JP-14'
  | 'JP_region_JP-15'
  | 'JP_region_JP-16'
  | 'JP_region_JP-17'
  | 'JP_region_JP-18'
  | 'JP_region_JP-19'
  | 'JP_region_JP-20'
  | 'JP_region_JP-21'
  | 'JP_region_JP-22'
  | 'JP_region_JP-23'
  | 'JP_region_JP-24'
  | 'JP_region_JP-25'
  | 'JP_region_JP-26'
  | 'JP_region_JP-27'
  | 'JP_region_JP-28'
  | 'JP_region_JP-29'
  | 'JP_region_JP-30'
  | 'JP_region_JP-31'
  | 'JP_region_JP-32'
  | 'JP_region_JP-33'
  | 'JP_region_JP-34'
  | 'JP_region_JP-35'
  | 'JP_region_JP-36'
  | 'JP_region_JP-37'
  | 'JP_region_JP-38'
  | 'JP_region_JP-39'
  | 'JP_region_JP-40'
  | 'JP_region_JP-41'
  | 'JP_region_JP-42'
  | 'JP_region_JP-43'
  | 'JP_region_JP-44'
  | 'JP_region_JP-45'
  | 'JP_region_JP-46'
  | 'JP_region_JP-47'
  | 'july'
  | 'july_app_image_alt'
  | 'july_app_ui'
  | 'july_app_ui_2025'
  | 'june'
  | 'june_app_image_alt'
  | 'june_app_ui'
  | 'june_app_ui_2025'
  | 'keep_ring_looking_best_copy'
  | 'keep_ring_looking_best_list'
  | 'keep_ring_looking_best_list_fragment'
  | 'keep_ring_looking_best_title'
  | 'keep_scrolling_to_get_back'
  | 'language_preference'
  | 'last_updated_august_1_2025'
  | 'last_updated_july_23_2025'
  | 'last_updated_march_4_2024'
  | 'leadership_bio_adi_shammout'
  | 'leadership_bio_avonte_campinha_bacote'
  | 'leadership_bio_dorothy_kilroy'
  | 'leadership_bio_doug_sweeny'
  | 'leadership_bio_holly_shelton'
  | 'leadership_bio_judy_gilbert'
  | 'leadership_bio_kate_brinks'
  | 'leadership_bio_lauri_vuornos'
  | 'leadership_bio_michael_chapp'
  | 'leadership_bio_ricky'
  | 'leadership_bio_sean_brecker'
  | 'leadership_bio_tom_hale'
  | 'leadership_bio_tommi_heinonen'
  | 'leadership_cco'
  | 'leadership_ceo'
  | 'leadership_cfo'
  | 'leadership_chief_design_officer'
  | 'leadership_chro'
  | 'leadership_ciso'
  | 'leadership_cmdo'
  | 'leadership_cmo'
  | 'leadership_coo'
  | 'leadership_cpo'
  | 'leadership_daily_habit_adi_shammout'
  | 'leadership_daily_habit_avonte_campinha_bacote'
  | 'leadership_daily_habit_dorothy_kilroy'
  | 'leadership_daily_habit_doug_sweeny'
  | 'leadership_daily_habit_holly_shelton'
  | 'leadership_daily_habit_judy_gilbert'
  | 'leadership_daily_habit_kate_brinks'
  | 'leadership_daily_habit_lauri_vuornos'
  | 'leadership_daily_habit_michael_chapp'
  | 'leadership_daily_habit_ricky'
  | 'leadership_daily_habit_sean_brecker'
  | 'leadership_daily_habit_shyamal_patel'
  | 'leadership_daily_habit_tom_hale'
  | 'leadership_daily_habit_tommi_heinonen'
  | 'leadership_gc'
  | 'leadership_hero_copy'
  | 'leadership_hero_heading'
  | 'leadership_miklu_silvanto_daily_habit'
  | 'leadership_miklu_silvanto_description_updated'
  | 'leadership_miklu_silvanto_quote'
  | 'leadership_modal_cta'
  | 'leadership_quote_adi_shammout'
  | 'leadership_quote_avonte_campinha_bacote'
  | 'leadership_quote_dorothy_kilroy'
  | 'leadership_quote_doug_sweeny'
  | 'leadership_quote_holly_shelton'
  | 'leadership_quote_judy_gilbert'
  | 'leadership_quote_kate_brinks'
  | 'leadership_quote_michael_chapp'
  | 'leadership_quote_ricky'
  | 'leadership_quote_sean_brecker'
  | 'leadership_quote_shyamal_patel'
  | 'leadership_quote_tom_hale'
  | 'leadership_quote_tommi_heinonen'
  | 'leadership_sheetal_bio'
  | 'leadership_sheetal_daily_habit'
  | 'leadership_sheetal_quote'
  | 'leadership_sheetal_title'
  | 'leadership_shyamal_patel_bio_v2'
  | 'leadership_svp_hardware'
  | 'leadership_svp_science'
  | 'leadership_svp_software_engineering'
  | 'leadership_vp_communications'
  | 'learn_how'
  | 'learn_more'
  | 'learn_more_aria_label'
  | 'learning-and-dev-budget'
  | 'legal_disclaimer_translations'
  | 'les_a_image_alt'
  | 'les_a_quote'
  | 'limitation_of_liability'
  | 'limited_one_year_warranty'
  | 'limited_one_year_warranty_subcopy'
  | 'lindsay_alt'
  | 'lindsay_name'
  | 'lindsay_quote'
  | 'line_item_desc_ring'
  | 'link_placeholder'
  | 'list_item_placeholder'
  | 'listen_to_heart'
  | 'live_longer_healthier'
  | 'loading'
  | 'low_inventory_tag'
  | 'lululemon_campaign_message'
  | 'lululemon_true_identity_card_case_description'
  | 'lululemon_true_identity_card_case_name'
  | 'lunch_benefit'
  | 'mab_hero_copy'
  | 'mab_hero_heading'
  | 'maggi_alt'
  | 'maggi_quote'
  | 'main_content'
  | 'maintenance_back'
  | 'maintenance_common_email_address'
  | 'maintenance_common_submit'
  | 'maintenance_email_error'
  | 'maintenance_message_checkout'
  | 'maintenance_message_default'
  | 'maintenance_message_my_account'
  | 'maintenance_thank_you'
  | 'major_cards_accepted'
  | 'man_cheese_img_alt'
  | 'man_cross_fit_alt'
  | 'man_cup_img_alt'
  | 'man_exercise_alt'
  | 'man_forehead_img_alt'
  | 'man_jogging_img_alt'
  | 'man_lying_down_alt'
  | 'man_smartphone_image_alt'
  | 'man_stomach_img_alt'
  | 'man_taking_photo_img_alt'
  | 'man_tie_img_alt'
  | 'man_typing_alt'
  | 'man_window_alt'
  | 'manage_cookies'
  | 'manage_your_oura_membership'
  | 'managing_cookies'
  | 'manufacturing_defects'
  | 'march_2023'
  | 'mastercard'
  | 'matthew_walker'
  | 'max_charging_case_limit_copy'
  | 'may_2025'
  | 'mechanical_and_electrical'
  | 'meditate_app_ui'
  | 'meet'
  | 'meet_oura_ring_HRV'
  | 'meet_oura_ring_scroll_to_discover'
  | 'member_spotlight'
  | 'member_support'
  | 'members_copy'
  | 'members_heading'
  | 'membership_accolades_slide_1_text'
  | 'membership_accolades_slide_2_text'
  | 'membership_accolades_slide_3_text'
  | 'membership_accolades_slide_4_text'
  | 'membership_accolades_slide_6_text'
  | 'membership_accolades_slide_7_text'
  | 'membership_accolades_slide_8_text'
  | 'membership_accolades_slide_9_text'
  | 'membership_accolades_title'
  | 'membership_activity_card_author_image_alt'
  | 'membership_activity_card_copy'
  | 'membership_activity_card_quote'
  | 'membership_activity_card_tag'
  | 'membership_activity_card_title'
  | 'membership_benefit_alt'
  | 'membership_benefits_evolving_body'
  | 'membership_benefits_evolving_title'
  | 'membership_benefits_first_month_title'
  | 'membership_benefits_first_six_months_body'
  | 'membership_benefits_first_six_months_body_site_redesign'
  | 'membership_benefits_first_six_months_body_site_redesign_new'
  | 'membership_benefits_nonpaying_members_body'
  | 'membership_benefits_nonpaying_members_title'
  | 'membership_better_sleep_alt'
  | 'membership_complete_health_app_img'
  | 'membership_faq_answer_1'
  | 'membership_faq_answer_2'
  | 'membership_faq_answer_3'
  | 'membership_faq_answer_3_site_redesign'
  | 'membership_faq_answer_4'
  | 'membership_faq_answer_5'
  | 'membership_faq_answer_5_site_redesign'
  | 'membership_faq_answer_6_onemonth'
  | 'membership_faq_answer_7'
  | 'membership_faq_question_1'
  | 'membership_faq_question_2'
  | 'membership_faq_question_3'
  | 'membership_faq_question_4'
  | 'membership_faq_question_5'
  | 'membership_faq_question_6'
  | 'membership_faq_question_7'
  | 'membership_faq_title'
  | 'membership_feature_highlight_1_alt'
  | 'membership_feature_highlight_2_alt'
  | 'membership_feature_highlight_3_alt'
  | 'membership_feature_highlight_4_alt'
  | 'membership_features_and_so_much_more'
  | 'membership_features_audio_sessions_body'
  | 'membership_features_audio_sessions_title'
  | 'membership_features_bedtime_guidance_body'
  | 'membership_features_bedtime_guidance_title'
  | 'membership_features_close'
  | 'membership_features_highlight_body_temp'
  | 'membership_features_highlight_health_insights'
  | 'membership_features_highlight_heart_rate_monitoring'
  | 'membership_features_highlight_sleep_analysis'
  | 'membership_features_rest_mode_body'
  | 'membership_features_rest_mode_title'
  | 'membership_features_restorative_time_body'
  | 'membership_features_restorative_time_title'
  | 'membership_features_sp02_body'
  | 'membership_features_sp02_title'
  | 'membership_features_tags_body'
  | 'membership_features_tags_title'
  | 'membership_features_title'
  | 'membership_features_track_movement_body'
  | 'membership_features_track_movement_title'
  | 'membership_features_trends_body'
  | 'membership_features_trends_title'
  | 'membership_features_view_all_features'
  | 'membership_features_workout_heart_rate_tracking_body'
  | 'membership_features_workout_heart_rate_tracking_title'
  | 'membership_gives_body_voice'
  | 'membership_heart_card_author_image_alt'
  | 'membership_heart_card_copy'
  | 'membership_heart_card_quote'
  | 'membership_heart_card_tag'
  | 'membership_heart_card_title'
  | 'membership_hero_alt'
  | 'membership_hero_cta'
  | 'membership_hero_subtitle'
  | 'membership_hero_title'
  | 'membership_hub'
  | 'membership_jade_feature_02_alt'
  | 'membership_jade_feature_04_alt'
  | 'membership_jade_hero_alt'
  | 'membership_period_prediction_img'
  | 'membership_sleep_card_author_image_alt'
  | 'membership_sleep_card_quote'
  | 'membership_sleep_card_tag'
  | 'membership_sleep_card_title'
  | 'membership_stress_card_author_image_alt'
  | 'membership_stress_card_copy'
  | 'membership_stress_card_quote'
  | 'membership_stress_card_tag'
  | 'membership_stress_card_title'
  | 'membership_wellness_card_author_image_alt'
  | 'membership_wellness_card_copy'
  | 'membership_wellness_card_quote'
  | 'membership_wellness_card_title'
  | 'membership_women_health_card_author_image_alt'
  | 'membership_women_health_card_copy'
  | 'membership_women_health_card_quote'
  | 'membership_women_health_card_tag'
  | 'membership_women_health_card_title'
  | 'membership_your_health_alt'
  | 'membership_your_health_body'
  | 'membership_your_health_body_site_redesign'
  | 'membership_your_health_bottom'
  | 'membership_your_health_title'
  | 'memberships_fertile_window_img'
  | 'menu'
  | 'meta_checkout_button_label'
  | 'meta_checkout_subcopy'
  | 'meta_checkout_title'
  | 'meta_commerce_oura_website_link'
  | 'meta_data_404_title'
  | 'meta_data_about_us_title'
  | 'meta_data_accessibility_title'
  | 'meta_data_business_customer_success_title'
  | 'meta_data_business_description'
  | 'meta_data_business_tandc_title'
  | 'meta_data_business_title'
  | 'meta_data_careers_description'
  | 'meta_data_careers_title'
  | 'meta_data_ceramic_care_description'
  | 'meta_data_ceramic_care_title'
  | 'meta_data_ceramic_cloud_pdp_description'
  | 'meta_data_ceramic_cloud_pdp_title'
  | 'meta_data_ceramic_description'
  | 'meta_data_ceramic_midnight_pdp_description'
  | 'meta_data_ceramic_midnight_pdp_title'
  | 'meta_data_ceramic_petal_pdp_description'
  | 'meta_data_ceramic_petal_pdp_title'
  | 'meta_data_ceramic_pop_or4_description'
  | 'meta_data_ceramic_pop_title'
  | 'meta_data_ceramic_tide_pdp_description'
  | 'meta_data_ceramic_tide_pdp_title'
  | 'meta_data_ceramic_title'
  | 'meta_data_contact_description'
  | 'meta_data_contact_title'
  | 'meta_data_cookie_policy_title'
  | 'meta_data_declaration_of_conformity_title'
  | 'meta_data_extend_title'
  | 'meta_data_fitness_title'
  | 'meta_data_gift_description'
  | 'meta_data_gift_title'
  | 'meta_data_guidelines_for_commercial_use_title'
  | 'meta_data_heart_health_description'
  | 'meta_data_heart_health_title'
  | 'meta_data_heart_rate_monitoring_title'
  | 'meta_data_home_description'
  | 'meta_data_home_title'
  | 'meta_data_how_it_works_description'
  | 'meta_data_how_it_works_title'
  | 'meta_data_hrm_tc_title'
  | 'meta_data_impressum_description'
  | 'meta_data_impressum_title'
  | 'meta_data_integrations_description'
  | 'meta_data_integrations_title'
  | 'meta_data_membership_description'
  | 'meta_data_membership_title'
  | 'meta_data_open_graph_description'
  | 'meta_data_open_graph_title'
  | 'meta_data_pop_description'
  | 'meta_data_pop_or4_description'
  | 'meta_data_pop_title'
  | 'meta_data_press_description'
  | 'meta_data_press_title'
  | 'meta_data_previous_terms_and_conditions'
  | 'meta_data_privacy_policy_description'
  | 'meta_data_privacy_policy_title'
  | 'meta_data_regulatory_notices_ca_description'
  | 'meta_data_regulatory_notices_ca_title'
  | 'meta_data_science_and_research_description'
  | 'meta_data_science_and_research_title'
  | 'meta_data_security_center_description'
  | 'meta_data_security_center_title'
  | 'meta_data_shipping_information_description'
  | 'meta_data_shipping_information_title'
  | 'meta_data_sizing_description'
  | 'meta_data_sizing_title'
  | 'meta_data_social_use_agreement_description'
  | 'meta_data_social_use_agreement_title'
  | 'meta_data_store_description'
  | 'meta_data_store_title'
  | 'meta_data_terms_and_conditions_page_description'
  | 'meta_data_terms_and_conditions_page_title'
  | 'meta_data_terms_and_conditions_title'
  | 'meta_data_why_oura_description'
  | 'meta_data_why_oura_title'
  | 'meta_gen3_product_description'
  | 'meta_or4_product_description'
  | 'meta_size_modal_step_one'
  | 'meta_step_1_copy'
  | 'meta_step_1_subcopy'
  | 'meta_step_2_copy'
  | 'meta_step_2_subcopy'
  | 'meta_step_3_copy'
  | 'meta_step_3_subcopy'
  | 'meta_what_to_expect_meta_data_description'
  | 'meta_what_to_expect_meta_data_title'
  | 'meta_what_to_expect_title'
  | 'metabolic_glucose_app_ui'
  | 'metabolic_health'
  | 'metabolic_health_blog_article_biosensor'
  | 'metabolic_health_blog_article_poor_sleep'
  | 'metabolic_health_blog_article_stabilize'
  | 'metabolic_health_blog_hero'
  | 'metabolic_health_disclaimer_p1'
  | 'metabolic_health_disclaimer_p2'
  | 'metabolic_health_disclaimer_p3'
  | 'metabolic_health_disclaimer_p4'
  | 'metabolic_health_disclaimer_p5'
  | 'metabolic_health_features_glucose_header'
  | 'metabolic_health_features_glucose_subcopy'
  | 'metabolic_health_features_meals_copy'
  | 'metabolic_health_features_meals_header'
  | 'metabolic_health_hero_title'
  | 'metabolic_health_jumbotron_description'
  | 'metabolic_health_spec_title'
  | 'metabolic_health_specs_angles_subcopy'
  | 'metabolic_health_specs_fuel_subcopy'
  | 'metabolic_health_specs_header'
  | 'metabolic_health_specs_header_angles'
  | 'metabolic_health_specs_header_fuel'
  | 'metabolic_health_specs_header_tracking'
  | 'metabolic_health_specs_tracking_subcopy'
  | 'metabolic_hero_sub_copy'
  | 'metabolic_landing_page_meta_description'
  | 'metabolic_landing_page_meta_title'
  | 'metabolic_oura_advisor_app_ui'
  | 'metallic_or4_alt'
  | 'michael_chee'
  | 'michelle_l_image_alt'
  | 'michelle_l_quote'
  | 'midnight'
  | 'military'
  | 'miscellaneous'
  | 'modification_of_the_terms_and_services'
  | 'moments'
  | 'my_account_another_email'
  | 'my_account_cancel_order_confirmation'
  | 'my_account_cancel_order_error'
  | 'my_account_email'
  | 'my_account_email_body'
  | 'my_account_email_copyright'
  | 'my_account_email_error'
  | 'my_account_email_error_not_eligible'
  | 'my_account_email_footer'
  | 'my_account_email_header'
  | 'my_account_email_login_button'
  | 'my_account_email_subject'
  | 'my_account_email_success'
  | 'my_account_enter_email'
  | 'my_account_enter_email_orders'
  | 'my_account_expired_session'
  | 'my_account_footnote'
  | 'my_account_goto_eop_my_account_message'
  | 'my_account_membership_hub'
  | 'my_account_message_high_traffic'
  | 'my_account_need_help'
  | 'my_account_no_orders'
  | 'my_account_order_closed'
  | 'my_account_order_delivered'
  | 'my_account_order_pending_approval'
  | 'my_account_order_pending_fulfillment'
  | 'my_account_order_ring_size_needed'
  | 'my_account_order_status'
  | 'my_account_order_status_shipped'
  | 'my_account_order_table_action'
  | 'my_account_order_table_finish'
  | 'my_account_order_table_order'
  | 'my_account_order_table_size'
  | 'my_account_orders_error_link'
  | 'my_account_orders_error_message'
  | 'my_account_orders_learn_more_warranty'
  | 'my_account_orders_member_care_ticket'
  | 'my_account_orders_mission'
  | 'my_account_sign_in_point_1'
  | 'my_account_sign_in_point_2'
  | 'my_account_sign_in_point_3'
  | 'my_account_sign_in_submit'
  | 'my_account_sign_in_title'
  | 'my_account_support_center'
  | 'my_account_tabs_membership'
  | 'my_account_tabs_orders'
  | 'my_account_track_order'
  | 'my_account_update_size_confirmation'
  | 'my_account_update_size_error'
  | 'name'
  | 'naptakers_body'
  | 'naptakers_title'
  | 'natural_cycles_2_year_eyebrow'
  | 'natural_cycles_cart_trial_eyebrow'
  | 'natural_cycles_checkout_offer'
  | 'natural_cycles_how_do_i_have_ring_step_1_heading'
  | 'natural_cycles_oura_article_tag'
  | 'nature_science_of_sleep'
  | 'nav_experience'
  | 'nav_health_features'
  | 'nav_help_center'
  | 'nav_shop_all_products'
  | 'nav_sizing_guide'
  | 'nav_travel_case'
  | 'nc_free_trial_summary_cta_button'
  | 'nc_free_trial_summary_cta_description'
  | 'nc_free_trial_summary_cta_title'
  | 'nc_membership_description'
  | 'nc_membership_title'
  | 'new'
  | 'new_feature'
  | 'new_year_hero_copy'
  | 'new_year_hero_health_title'
  | 'new_year_hero_img_alt'
  | 'new_year_hero_longevity_title'
  | 'newsroom_jade_date'
  | 'newsroom_jade_subcopy'
  | 'newsroom_jade_title'
  | 'newsroom_link'
  | 'newsroom_movement_counts_date'
  | 'newsroom_movement_counts_subcopy'
  | 'newsroom_movement_counts_title'
  | 'newsroom_oura_surpasses_5m_rings_date'
  | 'newsroom_oura_surpasses_5m_rings_subcopy'
  | 'newsroom_oura_surpasses_5m_rings_title'
  | 'newsroom_preg_menopause_support_date'
  | 'newsroom_preg_menopause_support_subcopy'
  | 'newsroom_preg_menopause_support_title'
  | 'newsroom_ultrahuman_case_date'
  | 'newsroom_ultrahuman_case_subcopy'
  | 'newsroom_ultrahuman_case_title'
  | 'next'
  | 'next_billing'
  | 'next_delivery'
  | 'next_gift_options'
  | 'next_payment'
  | 'next_pickup_details'
  | 'next_shipping'
  | 'next_shipping_method'
  | 'next_slide_aria_label'
  | 'nightowls_earlybirds_body'
  | 'nightowls_earlybirds_title'
  | 'no'
  | 'nomad_affirm'
  | 'nomad_faq_answer_1'
  | 'nomad_faq_answer_2'
  | 'nomad_faq_answer_3'
  | 'nomad_faq_answer_3_2'
  | 'nomad_faq_answer_4'
  | 'nomad_faq_answer_4_2'
  | 'nomad_faq_answer_4_3'
  | 'nomad_faq_answer_4_4'
  | 'nomad_faq_answer_5'
  | 'nomad_faq_answer_6'
  | 'nomad_faq_answer_6_10'
  | 'nomad_faq_answer_6_11'
  | 'nomad_faq_answer_6_12'
  | 'nomad_faq_answer_6_2'
  | 'nomad_faq_answer_6_3'
  | 'nomad_faq_answer_6_4'
  | 'nomad_faq_answer_6_5'
  | 'nomad_faq_answer_6_6'
  | 'nomad_faq_answer_6_7'
  | 'nomad_faq_answer_6_8'
  | 'nomad_faq_answer_6_9'
  | 'nomad_faq_question_1'
  | 'nomad_faq_question_2'
  | 'nomad_faq_question_3'
  | 'nomad_faq_question_4'
  | 'nomad_faq_question_5'
  | 'nomad_faq_question_6'
  | 'nomad_lifestyle_image_closed_alt'
  | 'nomad_lifestyle_image_open_alt'
  | 'nomad_lifestyle_image_placement_alt'
  | 'nomad_lifestyle_image_purse_alt'
  | 'nomad_meta_description'
  | 'nomad_meta_title'
  | 'nomad_product_copy'
  | 'nomad_product_title'
  | 'nomad_size_copy'
  | 'nomad_warranty_included'
  | 'not_sure_which_compare_title'
  | 'notice_for_california_users'
  | 'notice_hsa_fsa_eligible'
  | 'notice_hsa_fsa_eligible_logo_inline'
  | 'notify_me'
  | 'notify_me_modal_submit'
  | 'npj_digital_medicine'
  | 'office_locations'
  | 'on_dialysis'
  | 'on_insulin'
  | 'on_sale_tag'
  | 'one'
  | 'online_claims'
  | 'open_roles'
  | 'optimize_your_sleep'
  | 'optional_gift_message'
  | 'optional_gift_message_label'
  | 'optional_gift_message_textarea_label'
  | 'or'
  | 'or_4_sizing_kit'
  | 'or3_sizing_tips_choose_finger_copy'
  | 'or3_sizing_tips_subtitle'
  | 'or3_sizing_tips_test_fit_copy_p1'
  | 'or3_sizing_tips_test_fit_copy_p2'
  | 'or3_sizing_tips_title'
  | 'or4_black_product_img_alt'
  | 'or4_brushed_silver_product_img_alt'
  | 'or4_ceramic_care'
  | 'or4_ceramic_video_title'
  | 'or4_free_size_kit'
  | 'or4_gold_product_img_alt'
  | 'or4_home_page_hero_alt'
  | 'or4_launch_cart_message'
  | 'or4_launch_chargers_cart_message'
  | 'or4_launch_mixed_cart_message'
  | 'or4_launch_orders_message'
  | 'or4_mem_activity_aad_ui'
  | 'or4_mem_activity_goals_ui'
  | 'or4_mem_activity_score_ui'
  | 'or4_mem_heart_bp_ui'
  | 'or4_mem_heart_cva_ui'
  | 'or4_mem_heart_graph_ui'
  | 'or4_mem_heart_hrv_ui'
  | 'or4_mem_heart_vo2_ui'
  | 'or4_mem_readiness_radar_ui'
  | 'or4_mem_readiness_score_ui'
  | 'or4_mem_stress_daytime_ui'
  | 'or4_mem_stress_resilience_ui'
  | 'or4_mem_womens_insights_ui'
  | 'or4_mem_womens_pp_ui'
  | 'or4_pop_mem_sleep_apnea_ui'
  | 'or4_pop_mem_sleep_bed_ui'
  | 'or4_pop_mem_sleep_chart_ui'
  | 'or4_pop_mem_sleep_score_ui'
  | 'or4_pop_mem_sleep_spo2_ui'
  | 'or4_ring_alt'
  | 'or4_rose_gold_product_img_alt'
  | 'or4_silver_product_img_alt'
  | 'or4_size_step_selection'
  | 'or4_sizing_tips_choose_finger_copy'
  | 'or4_sizing_tips_subtitle'
  | 'or4_sizing_tips_test_fit_copy_p1'
  | 'or4_sizing_tips_test_fit_copy_p2'
  | 'or4_sizing_tips_title'
  | 'or4_stealth_product_img_alt'
  | 'order_cart_id_missing'
  | 'order_invalid_warranty_country_found'
  | 'order_ledger_retail_delivery_fee'
  | 'order_ledger_shipping'
  | 'order_ledger_subtotal'
  | 'order_ledger_tax'
  | 'order_ledger_tax_exempt'
  | 'order_ledger_tax_gst_hst'
  | 'order_ledger_tax_included'
  | 'order_ledger_tax_pst'
  | 'order_ledger_tax_qst'
  | 'order_not_allowed_country'
  | 'order_summary'
  | 'order_unexpected_error'
  | 'oreo_lined_up_alt'
  | 'our_site'
  | 'our_values'
  | 'oura_and_extend_alt'
  | 'oura_app'
  | 'oura_fda_link'
  | 'oura_features_activity_description'
  | 'oura_features_heart_rate_title'
  | 'oura_features_readiness_description'
  | 'oura_features_readiness_title'
  | 'oura_features_sickness_description'
  | 'oura_features_sickness_title'
  | 'oura_features_subtitle'
  | 'oura_features_title'
  | 'oura_for_business'
  | 'oura_home_link'
  | 'oura_member'
  | 'oura_membership'
  | 'oura_membership_country_restriction'
  | 'oura_membership_country_restriction_learn_more'
  | 'oura_menstrual_link'
  | 'oura_merchant_label'
  | 'oura_nc_free_subcopy_1'
  | 'oura_nc_free_subcopy_2'
  | 'oura_platform'
  | 'oura_prego_link'
  | 'oura_ring'
  | 'oura_ring_4'
  | 'oura_ring_4_ceramic'
  | 'oura_ring_4_flash_sale_15_subtitle'
  | 'oura_ring_4_flash_sale_15_subtitle_usa'
  | 'oura_ring_4_flash_sale_july_eyebrow'
  | 'oura_ring_4_flash_sale_july_eyebrow_usa'
  | 'oura_ring_4_flash_sale_july_subtitle'
  | 'oura_ring_4_flash_sale_july_subtitle_usa'
  | 'oura_ring_4_flash_sale_july_tag'
  | 'oura_ring_4_flash_sale_title'
  | 'oura_ring_4_link'
  | 'oura_ring_4_prime_sale_hero_alt'
  | 'oura_ring_ceramic_care_kit_footnote'
  | 'oura_ring_creamy_bg_alt'
  | 'oura_sizing_kit'
  | 'oura_store_header'
  | 'oura_terms_of_delivery'
  | 'oura_terms_of_use'
  | 'out_of_stock_message'
  | 'out_of_stock_retailers'
  | 'out_of_stock_tag'
  | 'outside_the_countries_listed_above'
  | 'pagination_label_start_end_total'
  | 'paragraph_placeholder'
  | 'parental_leave'
  | 'partnership_fitness_alt'
  | 'partnership_hero_oreo_desktop'
  | 'partnership_hero_oreo_mobile'
  | 'partnerships_apollo'
  | 'partnerships_behavioral_health'
  | 'partnerships_behavioral_health_alt'
  | 'partnerships_behavioral_health_copy'
  | 'partnerships_cards_daily'
  | 'partnerships_cards_daily_copy'
  | 'partnerships_cards_deeper'
  | 'partnerships_cards_deeper_copy'
  | 'partnerships_cards_personalized'
  | 'partnerships_cards_personalized_copy'
  | 'partnerships_cards_womens_health'
  | 'partnerships_cards_womens_health_copy'
  | 'partnerships_clue'
  | 'partnerships_cronometer'
  | 'partnerships_daily_engagement_alt'
  | 'partnerships_deeper_insights_alt'
  | 'partnerships_engage_img'
  | 'partnerships_experience_copy'
  | 'partnerships_experience_title'
  | 'partnerships_fitness'
  | 'partnerships_fitness_copy'
  | 'partnerships_footer_action'
  | 'partnerships_footer_copy'
  | 'partnerships_footer_image_alt'
  | 'partnerships_headspace'
  | 'partnerships_hero_action'
  | 'partnerships_hero_copy'
  | 'partnerships_hero_image_alt'
  | 'partnerships_hero_title'
  | 'partnerships_integrations_talkspace_copy'
  | 'partnerships_integrations_thrive_global_copy'
  | 'partnerships_journey_copy'
  | 'partnerships_journey_title'
  | 'partnerships_link'
  | 'partnerships_member_copy'
  | 'partnerships_member_eyebrow'
  | 'partnerships_member_title'
  | 'partnerships_members_heart_health_three'
  | 'partnerships_meta_data_description'
  | 'partnerships_meta_data_title'
  | 'partnerships_metabolic_health'
  | 'partnerships_metabolic_health_alt'
  | 'partnerships_metabolic_health_copy'
  | 'partnerships_natural_cycles'
  | 'partnerships_noom'
  | 'partnerships_offering_apple_google_alt'
  | 'partnerships_offering_oura_api_alt'
  | 'partnerships_offerings_affiliates'
  | 'partnerships_offerings_affiliates_alt'
  | 'partnerships_offerings_affiliates_copy'
  | 'partnerships_offerings_api'
  | 'partnerships_offerings_api_action'
  | 'partnerships_offerings_api_copy'
  | 'partnerships_offerings_apple_or_google'
  | 'partnerships_offerings_apple_or_google_copy'
  | 'partnerships_offerings_brand'
  | 'partnerships_offerings_brand_alt'
  | 'partnerships_offerings_brand_copy'
  | 'partnerships_offerings_eyebrow'
  | 'partnerships_offerings_title'
  | 'partnerships_strava'
  | 'partnerships_trusted_by'
  | 'partnerships_wild'
  | 'partnerships_zero'
  | 'pause'
  | 'pay_with_hsa'
  | 'pay_with_hsa_subcopy'
  | 'payment_and_fees'
  | 'payment_form_loading'
  | 'payment_form_zuora_sika_message'
  | 'payment_method_clientconfigtimeout_exception'
  | 'payment_nopaymentmethodsavailable_exception'
  | 'payment_options'
  | 'payment_process_payment_error'
  | 'payment_process_payment_invalid_payment_method_type'
  | 'payment_process_payment_invalid_provider'
  | 'paypal'
  | 'pdp_add_to_cart'
  | 'pdp_back_to_pop'
  | 'pdp_carousel_alt_charger_set'
  | 'pdp_carousel_alt_charger_set_video'
  | 'pdp_carousel_alt_heritage_black_video'
  | 'pdp_carousel_alt_heritage_gold_video'
  | 'pdp_carousel_alt_heritage_silver_video'
  | 'pdp_carousel_alt_heritage_stealth_video'
  | 'pdp_carousel_alt_horizon_black_video'
  | 'pdp_carousel_alt_horizon_gold_video'
  | 'pdp_carousel_alt_horizon_rose_video'
  | 'pdp_carousel_alt_horizon_silver_video'
  | 'pdp_carousel_alt_horizon_stealth_video'
  | 'pdp_carousel_alt_horizon_titanium_video'
  | 'pdp_carousel_alt_mobile_app'
  | 'pdp_carousel_alt_ring_closeup'
  | 'pdp_carousel_alt_well_dressed_man'
  | 'pdp_carousel_alt_woman_sunset'
  | 'pdp_carousel_mobile_app_src'
  | 'pdp_discount_applied'
  | 'pdp_discount_error'
  | 'pdp_discount_error_expired'
  | 'pdp_discount_error_used'
  | 'pdp_discount_fit_on'
  | 'pdp_discount_flo_heritage_silver'
  | 'pdp_discount_flo_horizon_rose_gold'
  | 'pdp_discount_natural_cycles'
  | 'pdp_finish_title'
  | 'pdp_from'
  | 'pdp_heart_rate'
  | 'pdp_highlights'
  | 'pdp_highlights_battery_life'
  | 'pdp_highlights_titanium'
  | 'pdp_highlights_water_resistant'
  | 'pdp_horizon_breakthrough_accuracy_description'
  | 'pdp_horizon_breakthrough_accuracy_title'
  | 'pdp_horizon_breakthrough_battery_description'
  | 'pdp_horizon_breakthrough_battery_title'
  | 'pdp_horizon_breakthrough_design_description'
  | 'pdp_horizon_breakthrough_design_title'
  | 'pdp_horizon_breakthrough_image_alt'
  | 'pdp_horizon_breakthrough_sensors_description'
  | 'pdp_horizon_breakthrough_sensors_title'
  | 'pdp_horizon_breakthrough_subtitle'
  | 'pdp_horizon_breakthrough_title'
  | 'pdp_horizon_case_studies_ucsd_cta'
  | 'pdp_horizon_case_studies_ucsf_cta'
  | 'pdp_horizon_case_studies_wvu_cta'
  | 'pdp_horizon_description'
  | 'pdp_horizon_description_title'
  | 'pdp_horizon_membership_description_hrm'
  | 'pdp_horizon_membership_description_insights'
  | 'pdp_horizon_membership_description_sleep'
  | 'pdp_horizon_membership_description_temp'
  | 'pdp_horizon_membership_features_title'
  | 'pdp_horizon_onemonth_membership_trial'
  | 'pdp_horizon_onemonth_membership_trial_2'
  | 'pdp_horizon_onemonth_membership_trial_2_new'
  | 'pdp_horizon_period_prediction_title'
  | 'pdp_horizon_quote_1_text'
  | 'pdp_horizon_quote_2_text'
  | 'pdp_horizon_quote_3_text'
  | 'pdp_horizon_quote_4_text'
  | 'pdp_horizon_quote_5_text'
  | 'pdp_horizon_quote_6_text'
  | 'pdp_horizon_quote_7_text'
  | 'pdp_horizon_quote_8_text'
  | 'pdp_horizon_quote_9_text'
  | 'pdp_horizon_quote_slider_title'
  | 'pdp_horizon_research_case_studies_ucsd'
  | 'pdp_horizon_research_case_studies_ucsf'
  | 'pdp_horizon_research_case_studies_west_virginia'
  | 'pdp_horizon_research_description'
  | 'pdp_horizon_research_title'
  | 'pdp_horizon_sizing_modal_expect'
  | 'pdp_horizon_sizing_modal_learn_more'
  | 'pdp_horizon_sizing_modal_learn_more_watch'
  | 'pdp_horizon_sizing_modal_link'
  | 'pdp_horizon_sizing_modal_step_1_description'
  | 'pdp_horizon_sizing_modal_step_1_title'
  | 'pdp_horizon_sizing_modal_step_2_description'
  | 'pdp_horizon_sizing_modal_step_2_title'
  | 'pdp_horizon_sizing_modal_step_3_description'
  | 'pdp_horizon_sizing_modal_step_3_title'
  | 'pdp_horizon_sizing_modal_title'
  | 'pdp_horizon_spo2_title'
  | 'pdp_out_of_stock_button'
  | 'pdp_ring_color_black_title'
  | 'pdp_ring_color_brushed_silver_title'
  | 'pdp_ring_color_cloud_title'
  | 'pdp_ring_color_gold_title'
  | 'pdp_ring_color_midnight_title'
  | 'pdp_ring_color_petal_title'
  | 'pdp_ring_color_rose_gold_title'
  | 'pdp_ring_color_silver_label'
  | 'pdp_ring_color_stealth_title'
  | 'pdp_ring_color_tide_title'
  | 'pdp_ring_color_titanium_title'
  | 'pdp_select_style_and_finish'
  | 'pdp_selected_check_label'
  | 'pdp_seo_description_balance'
  | 'pdp_seo_description_charger_set'
  | 'pdp_seo_description_diamond'
  | 'pdp_seo_description_heritage'
  | 'pdp_seo_description_horizon'
  | 'pdp_seo_description_sizing_kit'
  | 'pdp_seo_description_stealth'
  | 'pdp_seo_title_balance_black'
  | 'pdp_seo_title_balance_diamond'
  | 'pdp_seo_title_balance_silver'
  | 'pdp_seo_title_charger_set'
  | 'pdp_seo_title_heritage_black'
  | 'pdp_seo_title_heritage_gold'
  | 'pdp_seo_title_heritage_silver'
  | 'pdp_seo_title_heritage_stealth'
  | 'pdp_seo_title_horizon_black'
  | 'pdp_seo_title_horizon_gold'
  | 'pdp_seo_title_horizon_rosegold'
  | 'pdp_seo_title_horizon_silver'
  | 'pdp_seo_title_horizon_stealth'
  | 'pdp_seo_title_horizon_titanium'
  | 'pdp_seo_title_or4_black'
  | 'pdp_seo_title_or4_brushed_silver'
  | 'pdp_seo_title_or4_gold'
  | 'pdp_seo_title_or4_rose_gold'
  | 'pdp_seo_title_or4_silver'
  | 'pdp_seo_title_or4_stealth'
  | 'pdp_seo_title_sizing_kit'
  | 'pdp_seo_title_stealth'
  | 'pdp_size'
  | 'pdp_size_modal_choose_the_right'
  | 'pdp_size_modal_size_at_home'
  | 'pdp_size_modal_size_in_person_best_buy_content'
  | 'pdp_size_modal_size_in_person_best_buy_title'
  | 'pdp_size_modal_size_video_text_link'
  | 'pdp_size_modal_step_1_content'
  | 'pdp_size_modal_step_1_title'
  | 'pdp_size_modal_step_2_content'
  | 'pdp_size_modal_step_2_content_04_2025'
  | 'pdp_size_modal_step_2_title'
  | 'pdp_size_modal_step_3_content'
  | 'pdp_size_modal_step_3_title'
  | 'pdp_size_modal_step_4_content'
  | 'pdp_size_modal_step_4_title'
  | 'pdp_size_selector_know_size'
  | 'pdp_size_step_charger_list_item_1'
  | 'pdp_size_step_charger_list_item_2'
  | 'pdp_size_step_kit_message'
  | 'pdp_size_step_message'
  | 'pdp_size_step_select_size'
  | 'pdp_slide_2_app_ui'
  | 'pdp_slideshow_thumbnail_label'
  | 'pdp_step'
  | 'pdp_step_know_size'
  | 'pdp_step_size_kit'
  | 'pdp_step_size_next'
  | 'pdp_step_style_next'
  | 'pdp_step_warranty_next'
  | 'pdp_style_accordian_title'
  | 'pdp_style_description_heritage'
  | 'pdp_style_description_horizon'
  | 'pdp_style_heritage'
  | 'pdp_style_horizon'
  | 'pdp_style_message'
  | 'pdp_style_oura_gen3'
  | 'pdp_style_oura_ring_4'
  | 'pdp_style_ouraring4'
  | 'pdp_style_ouraring4_cer'
  | 'pdp_style_title'
  | 'pdp_warranty'
  | 'pdp_warranty_step_title'
  | 'pdp_warranty_step_title_new'
  | 'period_prediction'
  | 'period_prediction_app_ui_img'
  | 'period_prediction_copy'
  | 'personal_insights_image_alt_3'
  | 'personalized_activity_goals_alt'
  | 'petal'
  | 'pinterest'
  | 'play'
  | 'plos_digital_health'
  | 'pop_become_a_member_copy'
  | 'pop_become_a_member_copy_ai_update'
  | 'pop_compare_models_copy'
  | 'pop_compare_models_title'
  | 'pop_footnote_how_accurate_is_oura'
  | 'pop_footnote_temperature_validated_accurate'
  | 'pop_gen4_accuracy_tab_1_copy'
  | 'pop_gen4_accuracy_tab_1_title'
  | 'pop_gen4_accuracy_tab_2_copy'
  | 'pop_gen4_accuracy_tab_2_title'
  | 'pop_gen4_accuracy_tab_3_copy'
  | 'pop_gen4_accuracy_tab_3_title'
  | 'pop_gen4_accuracy_title'
  | 'pop_gen4_accuracy_video_cta'
  | 'pop_gen4_battery_life_copy'
  | 'pop_gen4_battery_life_copy_v2'
  | 'pop_gen4_battery_life_footnote'
  | 'pop_gen4_battery_life_title'
  | 'pop_gen4_battery_life_title_v2'
  | 'pop_gen4_comfort_tab_1_copy'
  | 'pop_gen4_comfort_tab_1_title'
  | 'pop_gen4_comfort_tab_2_copy'
  | 'pop_gen4_comfort_tab_2_title'
  | 'pop_gen4_comfort_tab_3_copy'
  | 'pop_gen4_comfort_tab_3_title'
  | 'pop_gen4_comfort_title'
  | 'pop_gen4_comfort_video_cta'
  | 'pop_gen4_compare_copy'
  | 'pop_gen4_compare_featured_img_alt'
  | 'pop_gen4_compare_title'
  | 'pop_gen4_finishes_title'
  | 'pop_gen4_hero_copy'
  | 'pop_gen4_hero_title'
  | 'pop_gen4_long_term_health'
  | 'pop_gen4_long_term_health_copy'
  | 'pop_gen4_long_term_health_img_alt'
  | 'pop_gen4_long_term_health_img_src'
  | 'pop_gen4_long_term_health_title'
  | 'pop_gen4_membership_sleep_featured_img_alt'
  | 'pop_gen4_membership_title'
  | 'pop_gen4_posthero_copy'
  | 'pop_gen4_posthero_cta'
  | 'pop_gen4_posthero_title'
  | 'pop_gen4_tech_specs_battery_life_list'
  | 'pop_gen4_tech_specs_compatibility_list'
  | 'pop_gen4_tech_specs_connectivity_list'
  | 'pop_gen4_tech_specs_dimensions_list'
  | 'pop_gen4_tech_specs_materials_list'
  | 'pop_gen4_tech_specs_sensors_list'
  | 'pop_gen4_tech_specs_sensors_title'
  | 'pop_gen4_whats_included_charger_title'
  | 'pop_google_health_image_alt'
  | 'pop_hero_background_alt'
  | 'pop_hero_copy'
  | 'pop_hero_lower_price_chiclet_cta'
  | 'pop_hero_lower_price_chiclet_title'
  | 'pop_highlights_accuracy_bullets'
  | 'pop_highlights_accuracy_copy'
  | 'pop_highlights_accuracy_title'
  | 'pop_highlights_battery_copy'
  | 'pop_highlights_battery_title'
  | 'pop_highlights_battery_tooltip'
  | 'pop_highlights_eyebrow'
  | 'pop_highlights_horizon_silver_ring_alt'
  | 'pop_highlights_materials_bullets'
  | 'pop_highlights_materials_copy'
  | 'pop_highlights_materials_title'
  | 'pop_highlights_materials_tooltip'
  | 'pop_highlights_sensors_bullets'
  | 'pop_highlights_sensors_copy'
  | 'pop_highlights_sensors_title'
  | 'pop_highlights_title'
  | 'pop_integrations_title'
  | 'pop_lifestyle_book_image_alt'
  | 'pop_lifestyle_doctor_image_alt'
  | 'pop_lifestyle_office_image_alt'
  | 'pop_lifestyle_smiling_man_image_alt'
  | 'pop_lifestyle_soldier_image_alt'
  | 'pop_lifestyle_title'
  | 'pop_membership_24-7_heart_rate_monitoring_copy'
  | 'pop_membership_24-7_heart_rate_monitoring_title'
  | 'pop_membership_24-7_heart_rate_monitoring_ui_alt'
  | 'pop_membership_24-7_heart_rate_monitoring_ui_src'
  | 'pop_membership_activity_and_fitness_featured_img_alt'
  | 'pop_membership_activity_and_fitness_featured_or4_img_alt'
  | 'pop_membership_activity_and_fitness_tab_title'
  | 'pop_membership_activity_score_copy'
  | 'pop_membership_activity_score_title'
  | 'pop_membership_activity_score_ui_alt'
  | 'pop_membership_activity_score_ui_src'
  | 'pop_membership_automatic_activity_detection_title'
  | 'pop_membership_automatic_activity_detection_ui_alt'
  | 'pop_membership_automatic_activity_detection_ui_v2_src'
  | 'pop_membership_bedtime_guidance_copy'
  | 'pop_membership_bedtime_guidance_title'
  | 'pop_membership_bedtime_guidance_ui_alt'
  | 'pop_membership_bedtime_guidance_ui_src'
  | 'pop_membership_blood_oxygen_sensing_copy'
  | 'pop_membership_blood_oxygen_sensing_title'
  | 'pop_membership_blood_oxygen_sensing_ui_alt'
  | 'pop_membership_blood_oxygen_sensing_ui_src'
  | 'pop_membership_copy'
  | 'pop_membership_cycle_insights_copy'
  | 'pop_membership_cycle_insights_title'
  | 'pop_membership_cycle_insights_ui_alt'
  | 'pop_membership_cycle_insights_ui_src'
  | 'pop_membership_daytime_stress_title'
  | 'pop_membership_daytime_stress_ui_alt'
  | 'pop_membership_daytime_stress_ui_src'
  | 'pop_membership_eyebrow'
  | 'pop_membership_heart_health_featured_or4_img_alt'
  | 'pop_membership_heart_health_tab_title'
  | 'pop_membership_heart_rate_variability_copy'
  | 'pop_membership_heart_rate_variability_title'
  | 'pop_membership_heart_rate_variability_ui_alt'
  | 'pop_membership_heart_rate_variability_ui_src'
  | 'pop_membership_illness_detection_copy'
  | 'pop_membership_illness_detection_title'
  | 'pop_membership_illness_detection_ui_alt'
  | 'pop_membership_illness_detection_ui_src'
  | 'pop_membership_natural_cycles_integration_copy'
  | 'pop_membership_natural_cycles_integration_title'
  | 'pop_membership_natural_cycles_integration_ui_alt'
  | 'pop_membership_natural_cycles_integration_ui_src'
  | 'pop_membership_partner_integrations_copy'
  | 'pop_membership_partner_integrations_title'
  | 'pop_membership_partner_integrations_ui_alt'
  | 'pop_membership_partner_integrations_ui_src'
  | 'pop_membership_period_prediction_title'
  | 'pop_membership_period_prediction_ui_alt'
  | 'pop_membership_readiness_featured_or4_img_alt'
  | 'pop_membership_readiness_score_copy'
  | 'pop_membership_readiness_score_title'
  | 'pop_membership_readiness_score_ui_alt'
  | 'pop_membership_readiness_score_ui_src'
  | 'pop_membership_readiness_tab_title'
  | 'pop_membership_resilience_title'
  | 'pop_membership_resilience_ui_alt'
  | 'pop_membership_resilience_ui_src'
  | 'pop_membership_sleep_apnea_ui_alt'
  | 'pop_membership_sleep_featured_or4_img_alt'
  | 'pop_membership_sleep_score_copy'
  | 'pop_membership_sleep_score_title'
  | 'pop_membership_sleep_score_ui_alt'
  | 'pop_membership_sleep_score_ui_src'
  | 'pop_membership_sleep_stages_copy'
  | 'pop_membership_sleep_stages_title'
  | 'pop_membership_sleep_tab_title'
  | 'pop_membership_stress_featured_or4_img_alt'
  | 'pop_membership_stress_tab_title'
  | 'pop_membership_title'
  | 'pop_membership_womens_health_featured_img_alt'
  | 'pop_membership_womens_health_featured_or4_img_alt'
  | 'pop_membership_womens_health_tab_title'
  | 'pop_style_comparison_heritage_description'
  | 'pop_style_comparison_heritage_silver_alt'
  | 'pop_style_comparison_horizon_description'
  | 'pop_style_comparison_horizon_silver_alt'
  | 'pop_style_comparison_title'
  | 'pop_tech_specs_battery_copy'
  | 'pop_tech_specs_battery_title'
  | 'pop_tech_specs_compatibility_copy'
  | 'pop_tech_specs_compatibility_title'
  | 'pop_tech_specs_connectivity_copy'
  | 'pop_tech_specs_connectivity_title'
  | 'pop_tech_specs_dimensions_copy'
  | 'pop_tech_specs_dimensions_title'
  | 'pop_tech_specs_materials_copy'
  | 'pop_tech_specs_materials_title'
  | 'pop_tech_specs_title'
  | 'pop_tech_specs_water_resistant_copy'
  | 'pop_tech_specs_water_resistant_title'
  | 'pop_whats_included_charger_copy'
  | 'pop_whats_included_charger_title'
  | 'pop_whats_included_title'
  | 'powered_by'
  | 'powered_by_oura'
  | 'powered_by_oura_camel'
  | 'powerful_women_body'
  | 'powerful_women_title'
  | 'precautions'
  | 'pregnancy_insights'
  | 'pregnancy_insights_app_ui_img'
  | 'prego_insight_copy'
  | 'prego_insights_copy_v2'
  | 'press_600_partners_date'
  | 'press_600_partners_heading'
  | 'press_600_partners_subcopy'
  | 'press_best_buy_date'
  | 'press_best_buy_heading'
  | 'press_best_buy_subcopy'
  | 'press_body_literacy_date'
  | 'press_body_literacy_heading'
  | 'press_body_literacy_subcopy'
  | 'press_content_heading'
  | 'press_dexcom_date'
  | 'press_dexcom_subcopy'
  | 'press_dexcom_title'
  | 'press_expand_metabolic_copy'
  | 'press_expand_metabolic_date'
  | 'press_expand_metabolic_title'
  | 'press_eyebrow'
  | 'press_heart_health_launch_date'
  | 'press_heart_health_launch_heading'
  | 'press_heart_health_launch_subcopy'
  | 'press_hero_image_alt_text'
  | 'press_item_1_title'
  | 'press_item_1_title_2023'
  | 'press_john_lewis_launch_date'
  | 'press_john_lewis_launch_heading'
  | 'press_john_lewis_launch_subcopy'
  | 'press_list_title'
  | 'press_mab_new_members_date'
  | 'press_mab_new_members_heading'
  | 'press_mab_new_members_subcopy'
  | 'press_media_assets'
  | 'press_or4_release_date'
  | 'press_or4_release_subcopy'
  | 'press_or4_release_title'
  | 'press_oura_advisor_date'
  | 'press_oura_advisor_subcopy'
  | 'press_oura_advisor_title'
  | 'press_oura_helps_millions_date'
  | 'press_oura_helps_millions_heading'
  | 'press_oura_helps_millions_subcopy'
  | 'press_oura_lab_date'
  | 'press_oura_lab_heading'
  | 'press_oura_lab_subcopy'
  | 'press_proxy_acquisition_date'
  | 'press_proxy_acquisition_heading'
  | 'press_proxy_acquisition_subcopy'
  | 'press_read_article'
  | 'press_retail_best_buy_date'
  | 'press_retail_best_buy_heading'
  | 'press_retail_best_buy_subcopy'
  | 'press_section_primary_image_alt'
  | 'press_section_primary_image_alt_ai'
  | 'press_section_slide_label_1'
  | 'press_section_slide_label_2'
  | 'press_section_slide_label_3'
  | 'press_section_slide_label_cardiovascular'
  | 'press_section_slide_label_cnbc'
  | 'press_section_slide_label_heart_rate'
  | 'press_section_slide_label_heart_rate_accuracy'
  | 'press_section_slide_label_menstrual_cycle'
  | 'press_section_slide_label_natural_cycles'
  | 'press_section_slide_label_pregnancy'
  | 'press_section_slide_label_tech_crunch'
  | 'press_section_slide_label_verge'
  | 'press_series_d_date'
  | 'press_series_d_subcopy'
  | 'press_series_d_title'
  | 'press_stress_launch_date'
  | 'press_stress_launch_heading'
  | 'press_stress_launch_subcopy'
  | 'press_talkspace_partner_date'
  | 'press_talkspace_partner_heading'
  | 'press_talkspace_partner_subcopy'
  | 'press_title'
  | 'press_title_subheading'
  | 'previous_slide_aria_label'
  | 'previous_terms_and_conditions'
  | 'price_per_mo'
  | 'price_per_mo_2025'
  | 'privacy_policy'
  | 'privacy_policy_about_p1_oct_2024'
  | 'privacy_policy_activities_item5_oct_2024'
  | 'privacy_policy_activity_data_item6_oct_2024'
  | 'privacy_policy_birthdate_item3_oct_2024'
  | 'privacy_policy_commitment_heading'
  | 'privacy_policy_commitment_p1'
  | 'privacy_policy_commitment_p2'
  | 'privacy_policy_email_address_item1_oct_2024'
  | 'privacy_policy_gender_item2_oct_2024'
  | 'privacy_policy_generated_tags_item7_oct_2024'
  | 'privacy_policy_heart_rate_item1_oct_2024'
  | 'privacy_policy_height_weight_item4_oct_2024'
  | 'privacy_policy_ip_address_item2_oct_2024'
  | 'privacy_policy_metadata_item3_oct_2024'
  | 'privacy_policy_movement_item2_oct_2024'
  | 'privacy_policy_notes_tags_item6_oct_2024'
  | 'privacy_policy_oh_about_heading'
  | 'privacy_policy_oh_changes_heading'
  | 'privacy_policy_oh_changes_p1'
  | 'privacy_policy_oh_contact_heading'
  | 'privacy_policy_oh_contact_ourahealth'
  | 'privacy_policy_oh_contact_ouraring'
  | 'privacy_policy_oh_contact_p1'
  | 'privacy_policy_oh_cookies_heading'
  | 'privacy_policy_oh_cookies_p1'
  | 'privacy_policy_oh_cookies_p2'
  | 'privacy_policy_oh_cookies_p3'
  | 'privacy_policy_oh_personal_california_ccpa_heading'
  | 'privacy_policy_oh_personal_california_ccpa_p1'
  | 'privacy_policy_oh_personal_california_ccpa_p2'
  | 'privacy_policy_oh_personal_california_heading'
  | 'privacy_policy_oh_personal_california_info_heading'
  | 'privacy_policy_oh_personal_california_info_item1'
  | 'privacy_policy_oh_personal_california_info_item2'
  | 'privacy_policy_oh_personal_california_info_item3'
  | 'privacy_policy_oh_personal_california_info_p1'
  | 'privacy_policy_oh_personal_california_info_p1_oct_2024'
  | 'privacy_policy_oh_personal_california_info_p2'
  | 'privacy_policy_oh_personal_california_info_p2_oct_2024'
  | 'privacy_policy_oh_personal_california_right_to_appeal_p1'
  | 'privacy_policy_oh_personal_california_right_to_appeal_title'
  | 'privacy_policy_oh_personal_california_rights_correction_heading'
  | 'privacy_policy_oh_personal_california_rights_correction_p1'
  | 'privacy_policy_oh_personal_california_rights_correction_p1_oct_2024'
  | 'privacy_policy_oh_personal_california_rights_deletion_heading'
  | 'privacy_policy_oh_personal_california_rights_deletion_p1'
  | 'privacy_policy_oh_personal_california_rights_discrimination_heading'
  | 'privacy_policy_oh_personal_california_rights_discrimination_item1'
  | 'privacy_policy_oh_personal_california_rights_discrimination_item2'
  | 'privacy_policy_oh_personal_california_rights_discrimination_item3'
  | 'privacy_policy_oh_personal_california_rights_discrimination_item4'
  | 'privacy_policy_oh_personal_california_rights_discrimination_p1'
  | 'privacy_policy_oh_personal_california_rights_heading'
  | 'privacy_policy_oh_personal_california_rights_know_heading'
  | 'privacy_policy_oh_personal_california_rights_know_item1'
  | 'privacy_policy_oh_personal_california_rights_know_item2'
  | 'privacy_policy_oh_personal_california_rights_know_item3'
  | 'privacy_policy_oh_personal_california_rights_know_item4'
  | 'privacy_policy_oh_personal_california_rights_know_item5'
  | 'privacy_policy_oh_personal_california_rights_know_item6'
  | 'privacy_policy_oh_personal_california_rights_know_p1'
  | 'privacy_policy_oh_personal_california_rights_p1'
  | 'privacy_policy_oh_personal_california_rights_request_detail_p1'
  | 'privacy_policy_oh_personal_california_rights_request_detail_p2'
  | 'privacy_policy_oh_personal_california_rights_request_detail_p3'
  | 'privacy_policy_oh_personal_california_rights_request_p1'
  | 'privacy_policy_oh_personal_california_rights_requests_heading'
  | 'privacy_policy_oh_personal_data_disclosures_heading'
  | 'privacy_policy_oh_personal_data_disclosures_item1'
  | 'privacy_policy_oh_personal_data_disclosures_item2'
  | 'privacy_policy_oh_personal_data_disclosures_item3'
  | 'privacy_policy_oh_personal_data_disclosures_item4'
  | 'privacy_policy_oh_personal_data_disclosures_p1'
  | 'privacy_policy_oh_personal_data_disclosures_p2'
  | 'privacy_policy_oh_personal_data_heading'
  | 'privacy_policy_oh_personal_data_sharing_heading'
  | 'privacy_policy_oh_personal_data_sharing_item1'
  | 'privacy_policy_oh_personal_data_sharing_item2'
  | 'privacy_policy_oh_personal_data_sharing_item3'
  | 'privacy_policy_oh_personal_data_sharing_item4'
  | 'privacy_policy_oh_personal_data_sharing_item5'
  | 'privacy_policy_oh_personal_data_sharing_p1'
  | 'privacy_policy_oh_personal_data_sharing_p2'
  | 'privacy_policy_oh_personal_device_basis_heading'
  | 'privacy_policy_oh_personal_device_basis_item1'
  | 'privacy_policy_oh_personal_device_basis_item2'
  | 'privacy_policy_oh_personal_device_basis_item3'
  | 'privacy_policy_oh_personal_device_basis_item4'
  | 'privacy_policy_oh_personal_device_basis_p1'
  | 'privacy_policy_oh_personal_device_heading'
  | 'privacy_policy_oh_personal_device_purposes_heading'
  | 'privacy_policy_oh_personal_device_purposes_p1'
  | 'privacy_policy_oh_personal_device_source_heading'
  | 'privacy_policy_oh_personal_device_source_p1'
  | 'privacy_policy_oh_personal_device_source_p2'
  | 'privacy_policy_oh_personal_heading'
  | 'privacy_policy_oh_personal_p1'
  | 'privacy_policy_oh_personal_store_basis_heading'
  | 'privacy_policy_oh_personal_store_basis_item1'
  | 'privacy_policy_oh_personal_store_basis_item2'
  | 'privacy_policy_oh_personal_store_basis_item3'
  | 'privacy_policy_oh_personal_store_basis_item4'
  | 'privacy_policy_oh_personal_store_basis_p1'
  | 'privacy_policy_oh_personal_store_heading'
  | 'privacy_policy_oh_personal_store_purposes_heading'
  | 'privacy_policy_oh_personal_store_purposes_p1'
  | 'privacy_policy_oh_personal_store_source_heading'
  | 'privacy_policy_oh_personal_store_source_item1'
  | 'privacy_policy_oh_personal_store_source_item2'
  | 'privacy_policy_oh_personal_store_source_item3'
  | 'privacy_policy_oh_personal_store_source_item4'
  | 'privacy_policy_oh_personal_store_source_p1'
  | 'privacy_policy_oh_retention_heading'
  | 'privacy_policy_oh_retention_p1'
  | 'privacy_policy_oh_retention_p2'
  | 'privacy_policy_oh_retention_p4'
  | 'privacy_policy_oh_rights_heading'
  | 'privacy_policy_oh_rights_item1'
  | 'privacy_policy_oh_rights_item1_p1'
  | 'privacy_policy_oh_rights_item1_p2'
  | 'privacy_policy_oh_rights_item2'
  | 'privacy_policy_oh_rights_item2_p1'
  | 'privacy_policy_oh_rights_item3'
  | 'privacy_policy_oh_rights_item3_p1'
  | 'privacy_policy_oh_rights_item3_p2'
  | 'privacy_policy_oh_rights_item4'
  | 'privacy_policy_oh_rights_item4_p1'
  | 'privacy_policy_oh_rights_item4_p2'
  | 'privacy_policy_oh_rights_item5'
  | 'privacy_policy_oh_rights_item5_p1'
  | 'privacy_policy_oh_rights_item6'
  | 'privacy_policy_oh_rights_item6_p1'
  | 'privacy_policy_oh_rights_item7'
  | 'privacy_policy_oh_rights_p1'
  | 'privacy_policy_oh_rights_p2'
  | 'privacy_policy_oh_rights_p3'
  | 'privacy_policy_oh_rights_questions'
  | 'privacy_policy_oh_safeguarding_heading'
  | 'privacy_policy_oh_safeguarding_p1'
  | 'privacy_policy_oh_safeguarding_p2'
  | 'privacy_policy_oh_safeguarding_p3'
  | 'privacy_policy_oh_safeguarding_p4'
  | 'privacy_policy_oh_title'
  | 'privacy_policy_oh_transfers_heading'
  | 'privacy_policy_oh_transfers_p1'
  | 'privacy_policy_oh_transfers_p2'
  | 'privacy_policy_oh_transfers_p3'
  | 'privacy_policy_oh_transfers_p4'
  | 'privacy_policy_oh_transfers_p5'
  | 'privacy_policy_oura_teams_heading_oct_2024'
  | 'privacy_policy_oura_teams_p1_oct_2024'
  | 'privacy_policy_oura_teams_p2_oct_2024'
  | 'privacy_policy_oura_teams_p3_oct_2024'
  | 'privacy_policy_oura_teams_p4_oct_2024'
  | 'privacy_policy_oura_teams_p5_oct_2024'
  | 'privacy_policy_oura_teams_p6_oct_2024'
  | 'privacy_policy_oura_teams_p7_oct_2024'
  | 'privacy_policy_oura_teams_p8_oct_2024'
  | 'privacy_policy_oura_teams_p9_oct_2024'
  | 'privacy_policy_personal_data_sharing_p3_oct_2024'
  | 'privacy_policy_personal_device_purposes_item1_oct_2024'
  | 'privacy_policy_personal_device_purposes_item2_oct_2024'
  | 'privacy_policy_personal_device_purposes_item3_oct_2024'
  | 'privacy_policy_personal_device_purposes_item4_oct_2024'
  | 'privacy_policy_personal_device_purposes_item5_oct_2024'
  | 'privacy_policy_personal_device_purposes_item6_oct_2024'
  | 'privacy_policy_personal_device_purposes_item7_oct_2024'
  | 'privacy_policy_personal_device_purposes_item8_oct_2024'
  | 'privacy_policy_personal_device_source_item1_oct_2024'
  | 'privacy_policy_personal_device_source_item2_oct_2024'
  | 'privacy_policy_personal_device_source_item3_oct_2024'
  | 'privacy_policy_personal_device_source_item4_oct_2024'
  | 'privacy_policy_personal_device_source_item5_oct_2024'
  | 'privacy_policy_personal_device_source_item6_oct_2024'
  | 'privacy_policy_personal_device_source_p3_oct_2024'
  | 'privacy_policy_personal_device_source_p4_oct_2024'
  | 'privacy_policy_personal_store_purposes_item1_oct_2024'
  | 'privacy_policy_personal_store_purposes_item2_oct_2024'
  | 'privacy_policy_personal_store_purposes_item3_oct_2024'
  | 'privacy_policy_personal_store_purposes_item4_oct_2024'
  | 'privacy_policy_personal_store_purposes_item5_oct_2024'
  | 'privacy_policy_personal_store_purposes_item6_oct_2024'
  | 'privacy_policy_personal_store_purposes_item8_oct_2024'
  | 'privacy_policy_rights_item7_p1_oct_2024'
  | 'privacy_policy_sleep_item4_oct_2024'
  | 'privacy_policy_sleep_phases_item5_oct_2024'
  | 'privacy_policy_temperature_item3_oct_2024'
  | 'privacy_policy_title'
  | 'privacy_policy_updated_feb_2025'
  | 'privacy_policy_user_id_item1_oct_2024'
  | 'product_catalog_color_black'
  | 'product_catalog_color_black_lifestyle'
  | 'product_catalog_color_brushed_silver'
  | 'product_catalog_color_brushed_silver_angle'
  | 'product_catalog_color_brushed_silver_lifestyle'
  | 'product_catalog_color_cloud'
  | 'product_catalog_color_diamond'
  | 'product_catalog_color_gold'
  | 'product_catalog_color_gold_angle'
  | 'product_catalog_color_gold_lifestyle'
  | 'product_catalog_color_midnight'
  | 'product_catalog_color_petal'
  | 'product_catalog_color_rose_gold_lifestyle'
  | 'product_catalog_color_rosegold'
  | 'product_catalog_color_silver'
  | 'product_catalog_color_silver_lifestyle'
  | 'product_catalog_color_stealth'
  | 'product_catalog_color_stealth_angle'
  | 'product_catalog_color_stealth_lifestyle'
  | 'product_catalog_color_tide'
  | 'product_catalog_color_titanium'
  | 'product_design_award'
  | 'protect_data_private_policy_link'
  | 'protection_plan'
  | 'pulse_blog_eyebrow'
  | 'quest_diagnostics_biomarker_description'
  | 'quest_diagnostics_biomarker_title'
  | 'quest_diagnostics_tnc_text'
  | 'raf_2way_para1'
  | 'raf_2way_para5'
  | 'raf_2way_text_12'
  | 'raf_2way_text_13'
  | 'raf_2way_text_25'
  | 'read_more'
  | 'readiness_app_image_alt'
  | 'readiness_app_ui'
  | 'ready_when_you_are'
  | 'rebecca_robbins'
  | 'recipient_email'
  | 'recipients_information'
  | 'recovery_app_ui'
  | 'recovery_image_alt'
  | 'recruitment_contact_p1'
  | 'recruitment_contact_title'
  | 'recruitment_how_to_complain_p1'
  | 'recruitment_how_to_complain_p2'
  | 'recruitment_how_to_complain_title'
  | 'recruitment_info_disclosure_p1'
  | 'recruitment_info_disclosure_p2'
  | 'recruitment_info_disclosure_p3'
  | 'recruitment_info_disclosure_title'
  | 'recruitment_info_uses_p1'
  | 'recruitment_info_uses_p2'
  | 'recruitment_info_uses_p2_list'
  | 'recruitment_info_uses_p3'
  | 'recruitment_info_uses_subtitle_1'
  | 'recruitment_info_uses_subtitle_2'
  | 'recruitment_info_uses_subtitle_3'
  | 'recruitment_info_uses_title'
  | 'recruitment_personal_data_storage_p1'
  | 'recruitment_personal_data_storage_p10'
  | 'recruitment_personal_data_storage_p10_list'
  | 'recruitment_personal_data_storage_p11'
  | 'recruitment_personal_data_storage_p12'
  | 'recruitment_personal_data_storage_p12_list'
  | 'recruitment_personal_data_storage_p2'
  | 'recruitment_personal_data_storage_p3'
  | 'recruitment_personal_data_storage_p4'
  | 'recruitment_personal_data_storage_p5'
  | 'recruitment_personal_data_storage_p6'
  | 'recruitment_personal_data_storage_p7'
  | 'recruitment_personal_data_storage_p8'
  | 'recruitment_personal_data_storage_p9'
  | 'recruitment_personal_data_storage_p9_list'
  | 'recruitment_personal_data_storage_subtitle_1'
  | 'recruitment_personal_data_storage_subtitle_2'
  | 'recruitment_personal_data_storage_subtitle_3'
  | 'recruitment_personal_data_storage_subtitle_4'
  | 'recruitment_personal_data_storage_title'
  | 'recruitment_personal_info_p1'
  | 'recruitment_personal_info_p1_list'
  | 'recruitment_personal_info_p2'
  | 'recruitment_personal_info_p3'
  | 'recruitment_personal_info_p4'
  | 'recruitment_personal_info_subtitle_1'
  | 'recruitment_personal_info_subtitle_2'
  | 'recruitment_personal_info_title'
  | 'recruitment_privacy_notice_p1'
  | 'recruitment_privacy_notice_p2'
  | 'recruitment_privacy_notice_p3'
  | 'recruitment_privacy_notice_p4'
  | 'recruitment_privacy_notice_p5'
  | 'recruitment_privacy_notice_title'
  | 'recruitment_privacy_policy_meta_data_description'
  | 'recruitment_privacy_policy_meta_data_title'
  | 'recycling_program_link'
  | 'relaxed_app_ui_src'
  | 'relaxed_card_tag'
  | 'release_april_21_2025'
  | 'remove_item'
  | 'remove_items'
  | 'remove_warranty_button_text'
  | 'reproductive_health'
  | 'reproductive_health_hero_alt'
  | 'reproductive_health_phone_2_src'
  | 'required'
  | 'research'
  | 'research_title'
  | 'rest_mode'
  | 'rest_mode_body'
  | 'restorative_time'
  | 'restorative_time_body'
  | 'restored_app_ui_src'
  | 'restored_card_tag'
  | 'retry'
  | 'return'
  | 'return_or_exchange'
  | 'review_cart'
  | 'review_order'
  | 'ring'
  | 'ring_food_alt'
  | 'ring_gen_3'
  | 'ring_gen_4'
  | 'ring_gen_4_cer'
  | 'ring_gen3_on_sale'
  | 'ring_membership_hsa'
  | 'ring_model_guide'
  | 'ring_pdp_2025_2_year_warranty_summary'
  | 'ring_pdp_2025_3_year_warranty_summary'
  | 'ring_pdp_2025_battery_disclaimer'
  | 'ring_pdp_2025_black_primary_image_alt'
  | 'ring_pdp_2025_brushed_silver_primary_image_alt'
  | 'ring_pdp_2025_cart_limit_copy'
  | 'ring_pdp_2025_charger_set_or4_description'
  | 'ring_pdp_2025_charger_set_or4_title'
  | 'ring_pdp_2025_current_member_summary'
  | 'ring_pdp_2025_explore_other_products'
  | 'ring_pdp_2025_faq_1_answer'
  | 'ring_pdp_2025_faq_1_question'
  | 'ring_pdp_2025_faq_2_answer'
  | 'ring_pdp_2025_faq_2_question'
  | 'ring_pdp_2025_faq_3_answer'
  | 'ring_pdp_2025_faq_3_list'
  | 'ring_pdp_2025_faq_3_question'
  | 'ring_pdp_2025_faq_4_answer'
  | 'ring_pdp_2025_faq_4_question'
  | 'ring_pdp_2025_faq_5_answer'
  | 'ring_pdp_2025_faq_5_question'
  | 'ring_pdp_2025_faqs_section_title'
  | 'ring_pdp_2025_gold_primary_image_alt'
  | 'ring_pdp_2025_hero_subtitle'
  | 'ring_pdp_2025_hsa_fsa_eligible_info_label'
  | 'ring_pdp_2025_hsa_fsa_eligible_label'
  | 'ring_pdp_2025_hsa_fsa_modal_heading'
  | 'ring_pdp_2025_hsa_fsa_modal_img_alt'
  | 'ring_pdp_2025_hsa_fsa_modal_list'
  | 'ring_pdp_2025_hsa_fsa_modal_title'
  | 'ring_pdp_2025_lifestyle_card_1_copy'
  | 'ring_pdp_2025_lifestyle_card_1_image_alt'
  | 'ring_pdp_2025_lifestyle_card_2_copy'
  | 'ring_pdp_2025_lifestyle_card_2_image_alt'
  | 'ring_pdp_2025_lifestyle_card_3_copy'
  | 'ring_pdp_2025_lifestyle_card_3_copy_v2'
  | 'ring_pdp_2025_lifestyle_card_3_image_alt'
  | 'ring_pdp_2025_lifestyle_section_card_1_copy'
  | 'ring_pdp_2025_lifestyle_section_card_2_copy'
  | 'ring_pdp_2025_lifestyle_section_title'
  | 'ring_pdp_2025_membership_annual_bullet'
  | 'ring_pdp_2025_membership_annual_bullet_1'
  | 'ring_pdp_2025_membership_annual_bullet_2'
  | 'ring_pdp_2025_membership_annual_bullet_3'
  | 'ring_pdp_2025_membership_annual_bullet_4'
  | 'ring_pdp_2025_membership_description'
  | 'ring_pdp_2025_membership_existing_subtitle'
  | 'ring_pdp_2025_membership_modal_features_copy'
  | 'ring_pdp_2025_membership_modal_features_heading'
  | 'ring_pdp_2025_membership_modal_footnote'
  | 'ring_pdp_2025_membership_modal_label'
  | 'ring_pdp_2025_membership_modal_title'
  | 'ring_pdp_2025_membership_option_annual'
  | 'ring_pdp_2025_membership_option_existing'
  | 'ring_pdp_2025_membership_option_monthly'
  | 'ring_pdp_2025_membership_section_copy'
  | 'ring_pdp_2025_membership_section_copy_v2'
  | 'ring_pdp_2025_membership_section_highlight_1'
  | 'ring_pdp_2025_membership_section_highlight_2'
  | 'ring_pdp_2025_membership_section_highlight_3'
  | 'ring_pdp_2025_membership_section_highlight_4'
  | 'ring_pdp_2025_membership_section_highlight_5'
  | 'ring_pdp_2025_membership_section_highlight_6'
  | 'ring_pdp_2025_membership_section_title'
  | 'ring_pdp_2025_membership_selection_subtitle'
  | 'ring_pdp_2025_monthly_membership_summary'
  | 'ring_pdp_2025_oos_modal_copy'
  | 'ring_pdp_2025_oos_modal_subtitle'
  | 'ring_pdp_2025_oos_modal_title'
  | 'ring_pdp_2025_ring_collection_image_alt'
  | 'ring_pdp_2025_rose_gold_primary_image_alt'
  | 'ring_pdp_2025_selected_ring_subtitle'
  | 'ring_pdp_2025_selected_ring_title'
  | 'ring_pdp_2025_selection_hsa_fsa_footnote'
  | 'ring_pdp_2025_silver_primary_image_alt'
  | 'ring_pdp_2025_size_modal_label'
  | 'ring_pdp_2025_size_option_description'
  | 'ring_pdp_2025_size_option_select_size'
  | 'ring_pdp_2025_size_option_sizing_kit'
  | 'ring_pdp_2025_size_selection_drawer_footnote'
  | 'ring_pdp_2025_size_selection_subtitle'
  | 'ring_pdp_2025_size_summary'
  | 'ring_pdp_2025_sizing_modal_footnote_1'
  | 'ring_pdp_2025_sizing_modal_in_store_sizing'
  | 'ring_pdp_2025_sizing_modal_step_1_copy'
  | 'ring_pdp_2025_sizing_modal_step_1_title'
  | 'ring_pdp_2025_sizing_modal_step_2_copy'
  | 'ring_pdp_2025_sizing_modal_step_2_title'
  | 'ring_pdp_2025_sizing_modal_step_3_copy'
  | 'ring_pdp_2025_sizing_modal_step_3_title'
  | 'ring_pdp_2025_sizing_modal_step_4_copy'
  | 'ring_pdp_2025_sizing_modal_step_4_title'
  | 'ring_pdp_2025_sizing_modal_title'
  | 'ring_pdp_2025_stealth_primary_image_alt'
  | 'ring_pdp_2025_stelo_description'
  | 'ring_pdp_2025_stelo_title'
  | 'ring_pdp_2025_tech_specs_battery_list'
  | 'ring_pdp_2025_tech_specs_battery_list_v2'
  | 'ring_pdp_2025_tech_specs_battery_title'
  | 'ring_pdp_2025_tech_specs_compatibility_list'
  | 'ring_pdp_2025_tech_specs_compatibility_title'
  | 'ring_pdp_2025_tech_specs_connectivity_list'
  | 'ring_pdp_2025_tech_specs_connectivity_title'
  | 'ring_pdp_2025_tech_specs_dimensions_list'
  | 'ring_pdp_2025_tech_specs_dimensions_title'
  | 'ring_pdp_2025_tech_specs_included_list'
  | 'ring_pdp_2025_tech_specs_included_title'
  | 'ring_pdp_2025_tech_specs_materials_list'
  | 'ring_pdp_2025_tech_specs_materials_title'
  | 'ring_pdp_2025_tech_specs_sensors_list'
  | 'ring_pdp_2025_tech_specs_sensors_title'
  | 'ring_pdp_2025_tech_specs_title'
  | 'ring_pdp_2025_trial_membership_footnote'
  | 'ring_pdp_2025_warranty_1_year_subtitle'
  | 'ring_pdp_2025_warranty_2_year_bullet'
  | 'ring_pdp_2025_warranty_3_year_subtitle'
  | 'ring_pdp_2025_warranty_modal_2_and_3_year_copy'
  | 'ring_pdp_2025_warranty_modal_2_and_3_year_heading'
  | 'ring_pdp_2025_warranty_modal_eyebrow'
  | 'ring_pdp_2025_warranty_modal_footnote'
  | 'ring_pdp_2025_warranty_modal_label'
  | 'ring_pdp_2025_warranty_modal_title'
  | 'ring_pdp_2025_warranty_option_1_year'
  | 'ring_pdp_2025_warranty_option_2_year'
  | 'ring_pdp_2025_warranty_option_3_year'
  | 'ring_pdp_2025_warranty_selection_subtitle'
  | 'ring_pdp_2025_whats_included_image_alt'
  | 'ring_ship_to_delivery_address'
  | 'ring_with_charger_image_alt'
  | 'rings'
  | 'robbins_bio'
  | 'robbins_title'
  | 'sale'
  | 'sale_gen3_eyebrow'
  | 'sale_link'
  | 'san_francisco'
  | 'san_francisco_and_san_diego'
  | 'sara_gottfried'
  | 'save'
  | 'sc_commitment_heading'
  | 'sc_commitment_p1'
  | 'sc_commitment_p1_5_2025'
  | 'sc_compliance_and_regulations_gdpr_p1'
  | 'sc_compliance_and_regulations_gdpr_subheading'
  | 'sc_compliance_and_regulations_heading'
  | 'sc_compliance_and_regulations_us_and_fed_p1'
  | 'sc_compliance_and_regulations_us_and_fed_subheading'
  | 'sc_data_and_trust_title'
  | 'sc_data_flow_heading'
  | 'sc_data_flow_p1'
  | 'sc_data_flow_p2'
  | 'sc_data_flow_p2_5_2025'
  | 'sc_security_measures_cloud_p1'
  | 'sc_security_measures_cloud_subheading'
  | 'sc_security_measures_device_p1'
  | 'sc_security_measures_device_subheading'
  | 'sc_security_measures_education_p1'
  | 'sc_security_measures_education_subheading'
  | 'sc_security_measures_heading'
  | 'sc_security_measures_vulnerability_p1'
  | 'sc_security_measures_vulnerability_subheading'
  | 'sc_updated_5_2025'
  | 'sc_updated_6_2024'
  | 'sc_vulnerability_disclosure_heading'
  | 'sc_vulnerability_disclosure_p1'
  | 'sc_vulnerability_disclosure_p1_5_2025'
  | 'sc_vulnerability_disclosure_p2'
  | 'sc_vulnerability_disclosure_p2_5_2025'
  | 'science_and_reasearch_oura_advisor_img_alt'
  | 'science_and_research_ai_learn_description'
  | 'science_and_research_ai_learn_title'
  | 'science_and_research_callout_v1_b1'
  | 'science_and_research_callout_v1_b2'
  | 'science_and_research_callout_v1_b3'
  | 'science_and_research_callout_v1_description'
  | 'science_and_research_callout_v1_header'
  | 'science_and_research_callout_v1_title'
  | 'science_and_research_card_one_alt'
  | 'science_and_research_card_three_alt'
  | 'science_and_research_carousel_button'
  | 'science_and_research_carousel_description'
  | 'science_and_research_carousel_title'
  | 'science_and_research_cutting_edge'
  | 'science_and_research_eleni_jaswa'
  | 'science_and_research_elissa_epel'
  | 'science_and_research_footer_eyebrow'
  | 'science_and_research_footer_title'
  | 'science_and_research_hero_alt'
  | 'science_and_research_hero_description'
  | 'science_and_research_hero_eyebrow'
  | 'science_and_research_hero_title'
  | 'science_and_research_innovation_action'
  | 'science_and_research_innovation_description'
  | 'science_and_research_innovation_title'
  | 'science_and_research_jagmeet_singh'
  | 'science_and_research_jake_deutsch'
  | 'science_and_research_link'
  | 'science_and_research_matthew_walker'
  | 'science_and_research_medical_advisor_female_alt'
  | 'science_and_research_medical_advisor_male_alt'
  | 'science_and_research_michael_chee'
  | 'science_and_research_or4_card_two_alt'
  | 'science_and_research_oura_advisor_text_1'
  | 'science_and_research_oura_advisor_text_2'
  | 'science_and_research_oura_advisor_text_3'
  | 'science_and_research_oura_advisor_title'
  | 'science_and_research_rebecca_robbins'
  | 'science_and_research_san_diego_description'
  | 'science_and_research_san_diego_title'
  | 'science_and_research_san_francisco_description'
  | 'science_and_research_san_francisco_title'
  | 'science_and_research_sara_gottfried'
  | 'science_and_research_singapore_description'
  | 'science_and_research_singapore_title'
  | 'science_and_research_testimonials_one_description'
  | 'science_and_research_testimonials_one_title'
  | 'science_and_research_testimonials_three_description'
  | 'science_and_research_testimonials_three_title'
  | 'science_and_research_testimonials_two_description'
  | 'science_and_research_testimonials_two_title'
  | 'science_and_research_universities_five'
  | 'science_and_research_universities_four'
  | 'science_and_research_universities_four_2025'
  | 'science_and_research_universities_one'
  | 'science_and_research_universities_six'
  | 'science_and_research_universities_three'
  | 'science_and_research_universities_two'
  | 'science_direct'
  | 'science_reporter'
  | 'science_research_2025_activity_level'
  | 'science_research_2025_article_one_headline'
  | 'science_research_2025_article_three_headline'
  | 'science_research_2025_article_two_headline'
  | 'science_research_2025_average_heart_rate'
  | 'science_research_2025_average_pace'
  | 'science_research_2025_calories_burned'
  | 'science_research_2025_card_one_subtitle'
  | 'science_research_2025_card_three_subtitle'
  | 'science_research_2025_card_two_subtitle'
  | 'science_research_2025_cycle_day'
  | 'science_research_2025_cycle_phase'
  | 'science_research_2025_dime_study_copy'
  | 'science_research_2025_distance'
  | 'science_research_2025_fertile_window'
  | 'science_research_2025_hero_cta'
  | 'science_research_2025_hero_subtitle'
  | 'science_research_2025_hero_title'
  | 'science_research_2025_highlights_feature_study_headline'
  | 'science_research_2025_highlights_title'
  | 'science_research_2025_hra_copy'
  | 'science_research_2025_measure_title'
  | 'science_research_2025_nat_science_headline'
  | 'science_research_2025_nighttime_movement'
  | 'science_research_2025_npj_headline'
  | 'science_research_2025_ovulation_stat_copy'
  | 'science_research_2025_ovulation_stat_heading'
  | 'science_research_2025_peer_review_link'
  | 'science_research_2025_peer_review_subtitle'
  | 'science_research_2025_peer_review_title'
  | 'science_research_2025_period_prediction'
  | 'science_research_2025_plos_headline'
  | 'science_research_2025_research_banner_subtitle'
  | 'science_research_2025_research_banner_title'
  | 'science_research_2025_research_copy'
  | 'science_research_2025_research_stat_four_description'
  | 'science_research_2025_research_stat_four_title'
  | 'science_research_2025_research_stat_one_description'
  | 'science_research_2025_research_stat_one_title'
  | 'science_research_2025_research_stat_three_description'
  | 'science_research_2025_research_stat_three_title'
  | 'science_research_2025_research_stat_two_description'
  | 'science_research_2025_research_stat_two_title'
  | 'science_research_2025_research_title'
  | 'science_research_2025_science_direct_headline'
  | 'science_research_2025_science_reporter_headline'
  | 'science_research_2025_scripps_study_copy'
  | 'science_research_2025_sensors_copy'
  | 'science_research_2025_sensors_headline'
  | 'science_research_2025_sensors_list'
  | 'science_research_2025_sensors_title'
  | 'science_research_2025_sleep_regularity'
  | 'science_research_2025_sleep_stages'
  | 'science_research_2025_sleep_timing'
  | 'science_research_2025_spo2'
  | 'science_research_2025_sta_copy'
  | 'science_research_2025_step_count'
  | 'science_research_2025_study_one'
  | 'science_research_2025_study_three'
  | 'science_research_2025_study_two'
  | 'science_research_2025_temp_trends'
  | 'science_research_2025_validation_description'
  | 'science_research_2025_validation_title'
  | 'scroll_for_more'
  | 'scroll_teaser'
  | 'scroll_to_discover'
  | 'section_heading_placeholder'
  | 'secure_checkout'
  | 'security_audits_heading'
  | 'security_audits_list'
  | 'security_committed_heading'
  | 'security_committed_p1'
  | 'security_hero_eyebrow'
  | 'security_hero_heading'
  | 'security_hero_img_alt'
  | 'security_hero_subheading'
  | 'security_protect_data_heading'
  | 'security_protect_data_list'
  | 'security_responsible_disclosure_heading'
  | 'security_responsible_disclosure_img_alt'
  | 'security_responsible_disclosure_p1'
  | 'security_responsible_disclosure_p2'
  | 'see_all_positions'
  | 'see_open_positions'
  | 'sensors'
  | 'sensors_copy'
  | 'september_2023'
  | 'seven_days_battery_copy'
  | 'ship_yourself_description'
  | 'ship_yourself_label'
  | 'shipment_delayed'
  | 'shipping_delay_cart_message'
  | 'shipping_delay_timeframe'
  | 'shipping_delays'
  | 'shipping_info_faq_answer_1_1'
  | 'shipping_info_faq_answer_1_2'
  | 'shipping_info_faq_answer_2_1'
  | 'shipping_info_faq_answer_2_2'
  | 'shipping_info_faq_answer_2_3'
  | 'shipping_info_faq_answer_2_4'
  | 'shipping_info_faq_answer_2_5'
  | 'shipping_info_faq_answer_2_6'
  | 'shipping_info_faq_answer_2_7'
  | 'shipping_info_faq_answer_3_1'
  | 'shipping_info_faq_answer_3_2'
  | 'shipping_info_faq_answer_3_3'
  | 'shipping_info_faq_answer_3_4'
  | 'shipping_info_faq_answer_4_1'
  | 'shipping_info_faq_answer_4_2'
  | 'shipping_info_faq_answer_4_3'
  | 'shipping_info_faq_answer_5_1'
  | 'shipping_info_faq_answer_5_2'
  | 'shipping_info_faq_answer_6_1'
  | 'shipping_info_faq_answer_6_2'
  | 'shipping_info_faq_answer_7_1'
  | 'shipping_info_faq_answer_8_1'
  | 'shipping_info_faq_answer_8_2'
  | 'shipping_info_faq_answer_8_3'
  | 'shipping_info_faq_question_1'
  | 'shipping_info_faq_question_2'
  | 'shipping_info_faq_question_3'
  | 'shipping_info_faq_question_4'
  | 'shipping_info_faq_question_5'
  | 'shipping_info_faq_question_6'
  | 'shipping_learn_more'
  | 'shipping_method_description'
  | 'shipping_method_expedited_air'
  | 'shipping_method_shipping'
  | 'shipping_method_standard'
  | 'shipping_modal_footnote_countries'
  | 'shipping_modal_footnote_extra_charger'
  | 'shipping_modal_footnote_ring_delivery'
  | 'shipping_modal_holiday_eu_expedited'
  | 'shipping_modal_holiday_eu_heading'
  | 'shipping_modal_holiday_eu_standard'
  | 'shipping_modal_holiday_row_expedited'
  | 'shipping_modal_holiday_row_heading'
  | 'shipping_modal_holiday_row_standard'
  | 'shipping_modal_holiday_title'
  | 'shipping_modal_holiday_us_expedited'
  | 'shipping_modal_holiday_us_heading'
  | 'shipping_modal_holiday_us_standard'
  | 'shipping_modal_oura_sizing_kit'
  | 'shipping_modal_regional_row_standard'
  | 'shipping_modal_regional_title'
  | 'shipping_modal_regional_us'
  | 'shipping_modal_ring_delivery_after_size'
  | 'shipping_modal_ring_delivery_days'
  | 'shipping_modal_ring_delivery_days_expedited'
  | 'shipping_modal_ring_only'
  | 'shipping_modal_sizing_kit_delivery'
  | 'shipping_modal_sizing_kit_expedited'
  | 'shipping_modal_title'
  | 'shop'
  | 'shop_gift_cards'
  | 'shop_oura_ring_4'
  | 'shop_oura_ring_gen3'
  | 'shop_rings'
  | 'shop_sale'
  | 'shop_stelo'
  | 'shop_the_store'
  | 'simple_home_accolades_architectural_digest'
  | 'simple_home_accolades_usa_today'
  | 'simple_home_accolades_washington_post'
  | 'simple_home_h1'
  | 'simple_online_claims'
  | 'singh_bio'
  | 'singles_day_alt_text'
  | 'singles_day_hero_title'
  | 'singles_day_subcopy'
  | 'singles_day_tag'
  | 'sitewide_highest_discount_eyebrow_copy'
  | 'size_guide'
  | 'sizing_bestbuy_sizing_kit_button'
  | 'sizing_bestbuy_sizing_kit_text'
  | 'sizing_bestbuy_sizing_kit_title'
  | 'sizing_bestbuy_store'
  | 'sizing_bestbuy_store_locator'
  | 'sizing_choose_finger_title'
  | 'sizing_gen4_confirm_size_content'
  | 'sizing_gen4_hero_eyebrow'
  | 'sizing_gen4_hero_img_alt'
  | 'sizing_gen4_hero_title'
  | 'sizing_gen4_or3_video_label'
  | 'sizing_gen4_or4_video_label'
  | 'sizing_gen4_sizing_guides_or3_content'
  | 'sizing_gen4_sizing_guides_or3_cta'
  | 'sizing_gen4_sizing_guides_or3_title'
  | 'sizing_gen4_sizing_guides_or4_content'
  | 'sizing_gen4_sizing_guides_or4_cta'
  | 'sizing_gen4_sizing_guides_or4_title'
  | 'sizing_gen4_sizing_guides_title'
  | 'sizing_gen4_sizing_guides_title_after'
  | 'sizing_gen4_sizing_video_src'
  | 'sizing_in_store_now'
  | 'sizing_kit'
  | 'sizing_test_fit_title'
  | 'sizing_tips'
  | 'sizing_tips_confirm_size_copy'
  | 'sizing_title'
  | 'skate_boarding_alt'
  | 'skip_for_now'
  | 'sku_out_of_stock_notice'
  | 'sku_shipping_delay_notice'
  | 'sleeker_smarter_ring_title'
  | 'sleep'
  | 'sleep_and_rest_cta_article_one'
  | 'sleep_and_rest_cta_article_three'
  | 'sleep_and_rest_cta_article_two'
  | 'sleep_and_rest_cta_description'
  | 'sleep_and_rest_cta_eyebrow'
  | 'sleep_and_rest_cta_img_alt'
  | 'sleep_and_rest_cta_tag'
  | 'sleep_and_rest_cta_tag_alt'
  | 'sleep_and_rest_features_description_four'
  | 'sleep_and_rest_features_description_one'
  | 'sleep_and_rest_features_description_three'
  | 'sleep_and_rest_features_description_two'
  | 'sleep_and_rest_features_eyebrow'
  | 'sleep_and_rest_features_four_img'
  | 'sleep_and_rest_features_four_img_alt'
  | 'sleep_and_rest_features_one_img'
  | 'sleep_and_rest_features_one_img_alt'
  | 'sleep_and_rest_features_three_img'
  | 'sleep_and_rest_features_three_img_alt'
  | 'sleep_and_rest_features_title_four'
  | 'sleep_and_rest_features_title_one'
  | 'sleep_and_rest_features_title_three'
  | 'sleep_and_rest_features_title_two'
  | 'sleep_and_rest_features_two_img'
  | 'sleep_and_rest_features_two_img_alt'
  | 'sleep_and_rest_headline_description'
  | 'sleep_and_rest_headline_title'
  | 'sleep_and_rest_hero_description'
  | 'sleep_and_rest_hero_eyebrow'
  | 'sleep_and_rest_hero_one_img_alt'
  | 'sleep_and_rest_hero_or4_one_img_alt'
  | 'sleep_and_rest_hero_or4_two_img_alt'
  | 'sleep_and_rest_hero_title'
  | 'sleep_and_rest_integrations_apollo'
  | 'sleep_and_rest_integrations_cronometer'
  | 'sleep_and_rest_integrations_description'
  | 'sleep_and_rest_integrations_myfitnesspal'
  | 'sleep_and_rest_integrations_title'
  | 'sleep_and_rest_link'
  | 'sleep_and_rest_meta_description'
  | 'sleep_and_rest_meta_title'
  | 'sleep_and_rest_testimonial_one_eyebrow'
  | 'sleep_and_rest_testimonial_one_quote'
  | 'sleep_and_rest_testimonial_three_eyebrow'
  | 'sleep_and_rest_testimonial_three_quote'
  | 'sleep_and_rest_testimonial_two_eyebrow'
  | 'sleep_and_rest_testimonial_two_quote'
  | 'sleep_and_rest_testimonials_three_img_alt'
  | 'sleep_and_rest_testimonials_three_v2_img_alt'
  | 'sleep_and_rest_testimonials_two_img_alt'
  | 'sleep_app_image_alt'
  | 'sleep_deprived_parent_body'
  | 'sleep_deprived_parent_title'
  | 'sleep_rest_app_ui'
  | 'sleep_rest_tag'
  | 'slider_item_aria_label'
  | 'small_and_large_alt'
  | 'smart_sensing'
  | 'smart_team'
  | 'soccer_alt'
  | 'softbank_shops'
  | 'somo_tac_para_1'
  | 'somo_tac_para_5'
  | 'spo2_slide_5_alt'
  | 'sports'
  | 'sta_copy'
  | 'sta_heading'
  | 'standard_ground_shipping'
  | 'standard_shipping'
  | 'standard_shipping_fedex'
  | 'starting_out_body'
  | 'starting_out_title'
  | 'stelo_dexcom_cgm_2pack_variant'
  | 'stelo_dexcom_cgm_title'
  | 'stelo_glucose_biosensor'
  | 'stelo_glucose_biosensor_cart_addon_tagline'
  | 'stelo_glucose_biosensor_description'
  | 'stelo_intended_usage_intro'
  | 'stelo_notify_me_modal_confirmation_copy'
  | 'stelo_notify_me_modal_copy'
  | 'stelo_notify_me_modal_subtitle'
  | 'stelo_notify_me_modal_title'
  | 'stelo_pdp_disclaimer_1'
  | 'stelo_pdp_disclaimer_2'
  | 'stelo_pdp_disclaimer_3'
  | 'stelo_pdp_faqs_item_1_copy'
  | 'stelo_pdp_faqs_item_1_title'
  | 'stelo_pdp_faqs_item_2_copy'
  | 'stelo_pdp_faqs_item_2_title'
  | 'stelo_pdp_faqs_item_3_copy'
  | 'stelo_pdp_faqs_item_3_title'
  | 'stelo_pdp_faqs_item_4_copy'
  | 'stelo_pdp_faqs_item_4_title'
  | 'stelo_pdp_faqs_item_5_copy'
  | 'stelo_pdp_faqs_item_5_title'
  | 'stelo_pdp_faqs_title'
  | 'stelo_pdp_feature_highlight_1'
  | 'stelo_pdp_feature_highlight_2'
  | 'stelo_pdp_feature_highlight_3'
  | 'stelo_pdp_footnote_1'
  | 'stelo_pdp_footnote_2'
  | 'stelo_pdp_footnote_3'
  | 'stelo_pdp_footnote_4'
  | 'stelo_pdp_footnote_5'
  | 'stelo_pdp_footnote_6'
  | 'stelo_pdp_footnotes_bottom_copy'
  | 'stelo_pdp_footnotes_bottom_copy_05_2025'
  | 'stelo_pdp_glucose_ui'
  | 'stelo_pdp_hero_1_alt'
  | 'stelo_pdp_hero_2_alt'
  | 'stelo_pdp_hero_3_alt'
  | 'stelo_pdp_intro_description'
  | 'stelo_pdp_metabolic_health_copy'
  | 'stelo_pdp_metabolic_health_cta'
  | 'stelo_pdp_metabolic_health_feature_img_alt'
  | 'stelo_pdp_metabolic_health_title'
  | 'stelo_pdp_no_returns_or_exchanges'
  | 'stelo_pdp_oura_integration_body'
  | 'stelo_pdp_oura_integration_card_1_copy'
  | 'stelo_pdp_oura_integration_card_1_img_alt'
  | 'stelo_pdp_oura_integration_card_1_title'
  | 'stelo_pdp_oura_integration_card_2_copy'
  | 'stelo_pdp_oura_integration_card_2_img_alt'
  | 'stelo_pdp_oura_integration_card_2_title'
  | 'stelo_pdp_oura_integration_card_3_copy'
  | 'stelo_pdp_oura_integration_card_3_img_alt'
  | 'stelo_pdp_oura_integration_card_3_title'
  | 'stelo_pdp_oura_integration_feature_img_alt'
  | 'stelo_pdp_oura_integration_title'
  | 'stelo_pdp_seo_description'
  | 'stelo_pdp_seo_title'
  | 'stelo_pdp_tech_specs_battery_life_list'
  | 'stelo_pdp_tech_specs_compatibility_list'
  | 'stelo_pdp_tech_specs_connectivity_list'
  | 'stelo_pdp_tech_specs_dimensions_list'
  | 'stelo_pdp_tech_specs_materials_list'
  | 'stelo_pdp_tech_specs_sensors_list'
  | 'stelo_setting_the_standard_heading'
  | 'step_finish_title'
  | 'step_model_description'
  | 'step_model_title'
  | 'step_size_title'
  | 'step_style_model_tab'
  | 'step_style_title'
  | 'store_accessories_dexcom_caption'
  | 'store_accessories_gen3_charger_caption'
  | 'store_accessories_gift_cards_caption'
  | 'store_accessories_gift_cards_title'
  | 'store_accessories_or4_charger_caption'
  | 'store_accessories_or4_charging_case_caption'
  | 'store_from_price'
  | 'store_locator_distance'
  | 'store_locator_item_button_label'
  | 'store_locator_item_link_label'
  | 'store_locator_location_closed'
  | 'store_locator_location_open'
  | 'store_locator_no_results'
  | 'store_locator_number_results'
  | 'store_locator_postal_code_pattern_error'
  | 'store_locator_results_error'
  | 'store_or4_black_hover_image_alt'
  | 'store_or4_brushed_silver_hover_image_alt'
  | 'store_or4_gold_hover_image_alt'
  | 'store_or4_rose_gold_hover_image_alt'
  | 'store_or4_silver_hover_image_alt'
  | 'store_or4_stealth_hover_image_alt'
  | 'stress_app_ui'
  | 'stress_app_ui_daytime'
  | 'stress_app_ui_daytime_alt'
  | 'stress_app_ui_hrv'
  | 'stress_app_ui_hrv_alt'
  | 'stress_app_ui_resilience'
  | 'stress_app_ui_resilience_alt'
  | 'stress_app_ui_restorative'
  | 'stress_features_copy_1'
  | 'stress_features_copy_2'
  | 'stress_features_copy_3'
  | 'stress_features_copy_4'
  | 'stress_features_title_1'
  | 'stress_features_title_2'
  | 'stress_features_title_3'
  | 'stress_features_title_4'
  | 'stress_hero_backgammon_alt'
  | 'stress_hero_copy'
  | 'stress_hero_eyebrow'
  | 'stress_hero_title'
  | 'stress_hero_woman_destress_alt'
  | 'stress_integration_copy'
  | 'stress_integration_headspace'
  | 'stress_link'
  | 'stress_meta_data_description'
  | 'stress_meta_data_title'
  | 'stress_press_blog_alt'
  | 'stress_pulse_blog_1'
  | 'stress_pulse_blog_2'
  | 'stress_pulse_blog_3'
  | 'stress_pulse_blog_hero'
  | 'stress_tag'
  | 'stress_testimonial_alt_3'
  | 'stress_testimonial_copy'
  | 'stress_testimonial_eyebrow'
  | 'stress_testimonial_quote_1'
  | 'stress_testimonial_quote_2'
  | 'stress_testimonial_quote_3'
  | 'stress_testimonial_tag_1'
  | 'stress_testimonial_tag_2'
  | 'stress_testimonial_tag_3'
  | 'stress_to_test'
  | 'stretch_hand_img_alt'
  | 'stretch_legs_image_alt'
  | 'stretch_legs_notification'
  | 'stretch_legs_notify_app_ui'
  | 'submit'
  | 'submit_corrected_address'
  | 'submit_ring_size'
  | 'submit_size'
  | 'subscriptions'
  | 'suggested_address'
  | 'summary_app_ui'
  | 'symptom_radar_image_alt'
  | 'tab_item_host_party_img_1_aria_label'
  | 'tab_item_host_party_img_2_aria_label'
  | 'tab_item_start_day_img_aria_label'
  | 'tab_item_under_weather_img_alt'
  | 'tab_item_wind_down_img_alt'
  | 'tags'
  | 'tags_body'
  | 'talkspace_campaign_message'
  | 'tax_name_canada_gst'
  | 'tax_name_gst'
  | 'tax_name_quebec_qst'
  | 'tax_name_sales_tax'
  | 'tax_name_tax'
  | 'tax_name_vat'
  | 'tech_specs'
  | 'termination_cancellation'
  | 'terms_access_p_1'
  | 'terms_access_p_2'
  | 'terms_access_p_3'
  | 'terms_access_p_4'
  | 'terms_access_p_5'
  | 'terms_access_p_6'
  | 'terms_access_p_7'
  | 'terms_access_p_8'
  | 'terms_access_title'
  | 'terms_and_conditions_2025_p1'
  | 'terms_and_conditions_2025_p10'
  | 'terms_and_conditions_2025_p11'
  | 'terms_and_conditions_2025_p12'
  | 'terms_and_conditions_2025_p13'
  | 'terms_and_conditions_2025_p14'
  | 'terms_and_conditions_2025_p15'
  | 'terms_and_conditions_2025_p16'
  | 'terms_and_conditions_2025_p17'
  | 'terms_and_conditions_2025_p18'
  | 'terms_and_conditions_2025_p19'
  | 'terms_and_conditions_2025_p2'
  | 'terms_and_conditions_2025_p20'
  | 'terms_and_conditions_2025_p21'
  | 'terms_and_conditions_2025_p22'
  | 'terms_and_conditions_2025_p23'
  | 'terms_and_conditions_2025_p24'
  | 'terms_and_conditions_2025_p25'
  | 'terms_and_conditions_2025_p26'
  | 'terms_and_conditions_2025_p27'
  | 'terms_and_conditions_2025_p28'
  | 'terms_and_conditions_2025_p29'
  | 'terms_and_conditions_2025_p3'
  | 'terms_and_conditions_2025_p30'
  | 'terms_and_conditions_2025_p31'
  | 'terms_and_conditions_2025_p32'
  | 'terms_and_conditions_2025_p33'
  | 'terms_and_conditions_2025_p34'
  | 'terms_and_conditions_2025_p35'
  | 'terms_and_conditions_2025_p36'
  | 'terms_and_conditions_2025_p37'
  | 'terms_and_conditions_2025_p38'
  | 'terms_and_conditions_2025_p39'
  | 'terms_and_conditions_2025_p4'
  | 'terms_and_conditions_2025_p40'
  | 'terms_and_conditions_2025_p41'
  | 'terms_and_conditions_2025_p42'
  | 'terms_and_conditions_2025_p43'
  | 'terms_and_conditions_2025_p44'
  | 'terms_and_conditions_2025_p45'
  | 'terms_and_conditions_2025_p46'
  | 'terms_and_conditions_2025_p47'
  | 'terms_and_conditions_2025_p48'
  | 'terms_and_conditions_2025_p49'
  | 'terms_and_conditions_2025_p5'
  | 'terms_and_conditions_2025_p50'
  | 'terms_and_conditions_2025_p51'
  | 'terms_and_conditions_2025_p52'
  | 'terms_and_conditions_2025_p53'
  | 'terms_and_conditions_2025_p54'
  | 'terms_and_conditions_2025_p55'
  | 'terms_and_conditions_2025_p56'
  | 'terms_and_conditions_2025_p57'
  | 'terms_and_conditions_2025_p58'
  | 'terms_and_conditions_2025_p59'
  | 'terms_and_conditions_2025_p6'
  | 'terms_and_conditions_2025_p60'
  | 'terms_and_conditions_2025_p61'
  | 'terms_and_conditions_2025_p62'
  | 'terms_and_conditions_2025_p63'
  | 'terms_and_conditions_2025_p64'
  | 'terms_and_conditions_2025_p65'
  | 'terms_and_conditions_2025_p66'
  | 'terms_and_conditions_2025_p67'
  | 'terms_and_conditions_2025_p68'
  | 'terms_and_conditions_2025_p69'
  | 'terms_and_conditions_2025_p7'
  | 'terms_and_conditions_2025_p70'
  | 'terms_and_conditions_2025_p71'
  | 'terms_and_conditions_2025_p8'
  | 'terms_and_conditions_2025_p9'
  | 'terms_and_conditions_canada_header'
  | 'terms_and_conditions_header_1'
  | 'terms_and_conditions_header_10'
  | 'terms_and_conditions_header_11'
  | 'terms_and_conditions_header_12'
  | 'terms_and_conditions_header_13'
  | 'terms_and_conditions_header_14'
  | 'terms_and_conditions_header_15'
  | 'terms_and_conditions_header_16'
  | 'terms_and_conditions_header_2'
  | 'terms_and_conditions_header_3'
  | 'terms_and_conditions_header_4'
  | 'terms_and_conditions_header_5'
  | 'terms_and_conditions_header_6'
  | 'terms_and_conditions_header_7'
  | 'terms_and_conditions_header_8'
  | 'terms_and_conditions_header_9'
  | 'terms_and_conditions_link'
  | 'terms_and_conditions_privacy_policy_link'
  | 'terms_and_conditions_refer_link'
  | 'terms_and_conditions_text_1'
  | 'terms_and_conditions_text_10'
  | 'terms_and_conditions_text_11'
  | 'terms_and_conditions_text_12'
  | 'terms_and_conditions_text_13'
  | 'terms_and_conditions_text_14'
  | 'terms_and_conditions_text_15'
  | 'terms_and_conditions_text_16'
  | 'terms_and_conditions_text_17'
  | 'terms_and_conditions_text_18'
  | 'terms_and_conditions_text_19'
  | 'terms_and_conditions_text_2'
  | 'terms_and_conditions_text_20'
  | 'terms_and_conditions_text_21'
  | 'terms_and_conditions_text_22'
  | 'terms_and_conditions_text_23'
  | 'terms_and_conditions_text_24'
  | 'terms_and_conditions_text_25'
  | 'terms_and_conditions_text_26'
  | 'terms_and_conditions_text_27'
  | 'terms_and_conditions_text_28'
  | 'terms_and_conditions_text_29'
  | 'terms_and_conditions_text_3'
  | 'terms_and_conditions_text_4'
  | 'terms_and_conditions_text_6'
  | 'terms_and_conditions_text_7'
  | 'terms_and_conditions_text_8'
  | 'terms_and_conditions_text_9'
  | 'terms_delivery_last_updated'
  | 'terms_delivery_p_canada_uk'
  | 'terms_delivery_p_eu_usa'
  | 'terms_delivery_p_outside'
  | 'terms_delivery_subtitle_canada_uk'
  | 'terms_delivery_subtitle_eu_usa'
  | 'terms_delivery_subtitle_outside'
  | 'terms_delivery_title'
  | 'terms_last_updated'
  | 'terms_of_delivery_canada_description'
  | 'terms_of_delivery_dap_heading'
  | 'terms_of_service'
  | 'terms_of_use'
  | 'testimonial_anne_alt'
  | 'testimonial_carisamoore'
  | 'testimonial_chrispaul'
  | 'testimonial_dave_k_alt'
  | 'testimonial_kailenny'
  | 'testimonial_lindseyvonn'
  | 'testimonial_ted_n_alt'
  | 'testimonials_image_alt_carisamoore'
  | 'testimonials_image_alt_chrispaul'
  | 'testimonials_image_alt_kailenny'
  | 'testimonials_image_alt_lindseyvonn'
  | 'testimonials_image_alt_suvvey'
  | 'testimonials_title'
  | 'thank_you_for_your_order'
  | 'thank_you_for_your_order_delays'
  | 'the_european_union_and_usa'
  | 'the_pulse'
  | 'the_pulse_blog'
  | 'theres_a_lot_to_learn'
  | 'tide'
  | 'tiktok'
  | 'time_asleep_app_ui'
  | 'titanium_copy'
  | 'to_learn_more'
  | 'today'
  | 'tomorrow'
  | 'track_your_activity'
  | 'trends'
  | 'trends_body'
  | 'try_nc_for_free'
  | 'two_women_looking_at_phone_img_alt'
  | 'types_of_cookies'
  | 'under_18_years_of_age'
  | 'understand_your_body'
  | 'unlimited_support'
  | 'unsupported_country_error'
  | 'upgrade_faq'
  | 'upgrade_faq_link'
  | 'US_region_AK'
  | 'US_region_AL'
  | 'US_region_AR'
  | 'US_region_AZ'
  | 'US_region_CA'
  | 'US_region_CO'
  | 'US_region_CT'
  | 'US_region_DC'
  | 'US_region_DE'
  | 'US_region_FL'
  | 'US_region_GA'
  | 'US_region_HI'
  | 'US_region_IA'
  | 'US_region_ID'
  | 'US_region_IL'
  | 'US_region_IN'
  | 'US_region_KS'
  | 'US_region_KY'
  | 'US_region_LA'
  | 'US_region_MA'
  | 'US_region_MD'
  | 'US_region_ME'
  | 'US_region_MI'
  | 'US_region_MN'
  | 'US_region_MO'
  | 'US_region_MS'
  | 'US_region_MT'
  | 'US_region_NC'
  | 'US_region_ND'
  | 'US_region_NE'
  | 'US_region_NH'
  | 'US_region_NJ'
  | 'US_region_NM'
  | 'US_region_NV'
  | 'US_region_NY'
  | 'US_region_OH'
  | 'US_region_OK'
  | 'US_region_OR'
  | 'US_region_PA'
  | 'US_region_RI'
  | 'US_region_SC'
  | 'US_region_SD'
  | 'US_region_TN'
  | 'US_region_TX'
  | 'US_region_UT'
  | 'US_region_VA'
  | 'US_region_VT'
  | 'US_region_WA'
  | 'US_region_WI'
  | 'US_region_WV'
  | 'US_region_WY'
  | 'use_current_location_link'
  | 'use_existing_address'
  | 'video_alt_image_alt_default'
  | 'view_full_bio'
  | 'view_your_cart'
  | 'view_your_cart_with_quantity'
  | 'visa'
  | 'wagner_b_job_title'
  | 'wagner_quote'
  | 'walker_bio'
  | 'walker_title'
  | 'walshe_bio'
  | 'walshe_title'
  | 'want_to_learn_more'
  | 'warranty'
  | 'warranty_disclaimer'
  | 'warranty_replacement_free_shipping'
  | 'watch_the_film'
  | 'watch_the_video'
  | 'water_resistant'
  | 'water_resistant_copy'
  | 'ways_to_integrate_title'
  | 'wellness_app_ui'
  | 'wellness_benefit'
  | 'wellness_description'
  | 'wellness_subtitle'
  | 'wellness_tag'
  | 'wellness_time'
  | 'wellness_title'
  | 'what_cookies_are'
  | 'what_started_as_an_idea'
  | 'whatever_you_need'
  | 'why_oura'
  | 'why_oura_engaged_ui'
  | 'why_oura_footnote_sleep_staging_algorithm'
  | 'why_oura_hero_subtitle'
  | 'why_oura_hero_title'
  | 'why_oura_image_lifestyle_1_alt'
  | 'why_oura_image_lifestyle_2_alt'
  | 'why_oura_image_lifestyle_3_alt'
  | 'why_oura_link'
  | 'why_oura_phd_stat'
  | 'why_oura_relaxed_ui'
  | 'why_oura_research_stat'
  | 'why_oura_restored_ui'
  | 'why_oura_ring_members_stat'
  | 'why_we_use_cookies'
  | 'winter_sale'
  | 'winter_sale_copy'
  | 'with_problematic_hypoglycemia'
  | 'wizard_image_label_charger_set'
  | 'wizard_image_label_heritage_black'
  | 'wizard_image_label_heritage_gold'
  | 'wizard_image_label_heritage_silver'
  | 'wizard_image_label_heritage_stealth'
  | 'wizard_image_label_horizon_black'
  | 'wizard_image_label_horizon_gold'
  | 'wizard_image_label_horizon_rose'
  | 'wizard_image_label_horizon_silver'
  | 'wizard_image_label_horizon_stealth'
  | 'wizard_image_label_horizon_titanium'
  | 'wizard_tech_specs_image_alt'
  | 'wizard_tech_specs_title'
  | 'woman_close_up_image_alt'
  | 'woman_flowers_img_alt'
  | 'woman_hand_img_alt'
  | 'woman_jogging_img_alt'
  | 'woman_park_alt'
  | 'woman_shoe_img_alt'
  | 'woman_sleeping_image_alt'
  | 'woman_stretching_img_alt'
  | 'woman_yoga_img_alt'
  | 'women_sitting_app_alt'
  | 'womens_features_cycle_insights_img_alt'
  | 'womens_features_period_prediction_img_alt'
  | 'womens_features_pregnancy_insight_img_alt'
  | 'womens_health'
  | 'womens_health_hero_copy'
  | 'womens_health_hero_title'
  | 'womens_health_link'
  | 'womens_health_may_2024_app_ui_src_1'
  | 'womens_health_may_2024_app_ui_src_2'
  | 'womens_health_meta_data_description'
  | 'womens_health_meta_data_title'
  | 'womens_health_tag'
  | 'womens_integrations_apple_health_copy'
  | 'womens_integrations_clue_copy'
  | 'womens_integrations_copy'
  | 'womens_integrations_flo_copy'
  | 'womens_integrations_health_connect_copy'
  | 'womens_integrations_nc_copy'
  | 'womens_privacy_link'
  | 'womens_privacy_quote'
  | 'womens_privacy_title'
  | 'x'
  | 'yes'
  | 'you_entered'
  | 'your_potential_realized'
  | 'your_privacy_rights'
  | 'youtube'
  | 'zero_deductible';

export type LocaleMessagesJson = Record<MessageKey, string>;
